import { useState, useEffect, useRef } from "react";
import { initializeApp, getApps } from "firebase/app";
import { getDatabase, ref as dbRef, set, get, child, remove, onValue, off } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCT4hZ4PZfDLSp2RUPqxwQ3W_6x6OvvhZg",
  authDomain: "taxreliefgh.firebaseapp.com",
  projectId: "taxreliefgh",
  storageBucket: "taxreliefgh.appspot.com",
  databaseURL: "https://taxreliefgh-default-rtdb.firebaseio.com",
};
const fbApp = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const db = getDatabase(fbApp);

const FONTS = `@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=Lora:ital,wght@0,400;0,500;0,600;1,400&display=swap');`;

const CSS = `

${FONTS}
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --ink:#0f1923;--ink2:#263545;--muted:#6b7a8d;--border:#dde3ea;
  --bg:#f4f6f9;--card:#fff;--gold:#C9991A;--gold2:#F5C842;--gold-bg:#fffbf0;
  --green:#006B3F;--green2:#e6f4ed;--red:#CE1126;
  --r:10px;--sh:0 2px 16px rgba(15,25,35,.09);--shL:0 6px 36px rgba(15,25,35,.16);
}
body{font-family:'Lora',serif;background:var(--bg);color:var(--ink);min-height:100vh;transition:background .3s,color .3s;font-size:var(--app-font-size)}
h1,h2,h3,h4,h5{font-family:'Syne',sans-serif}
button,input,select,textarea{font-family:'Lora',serif}

/* ── DARK MODE ─────────────────────────────────────────── */
body.dark{
  --ink:#e2eaf2;--ink2:#a8bfd0;--muted:#7090a8;--border:#1e3048;
  --bg:#080f18;--card:#0d1b2a;--gold:#F5C842;--gold2:#ffe066;
  --green:#00a05e;--green2:#051a10;--red:#ff4d6a;
}
body.dark .nav{background:#040c14;border-bottom:1px solid #1e3048}
body.dark .hero{min-height:91vh;background:linear-gradient(140deg,#0f1923 0%,#1a3050 55%,#0d2610 100%);
  display:flex;flex-direction:column;align-items:center;justify-content:center;
  text-align:center;padding:72px 24px 56px;position:relative;overflow:hidden}
body.dark .bg-w{background:#0d1b2a}
body.dark .step,.dark .acard,.dark .icard,.dark .setcard,.dark .scard,.dark .vmgr,.dark .abox,.dark .pcard,.dark .modal{background:#0d1b2a;border-color:#1e3048}
body.dark .fbody{background:#0d1b2a;border-color:#1e3048}
body.dark .fhd{background:linear-gradient(135deg,#04090f,#0a1c30)}
body.dark .fi{background:#080f18;border-color:#1e3048;color:#e2eaf2}
body.dark .tabs{background:#080f18}
body.dark .tab.on{background:#0d1b2a;color:#e2eaf2}
body.dark thead th{background:#080f18;color:#7090a8}
body.dark tbody td{border-color:#1e3048}
body.dark tbody tr:hover td{background:#080f18}
body.dark .declbox{background:#080f18;border-color:#1e3048}
body.dark .upbox{border-color:#1e3048}
body.dark .upbox:hover{background:#080f18}
body.dark .ctbl th{background:#080f18}
body.dark .ctbl td{border-color:#1e3048}
body.dark .disc{background:linear-gradient(135deg,#1a1200,#120e00)}
body.dark .disc li{color:#c9a840}
body.dark .vitem{background:#080f18}
body.dark .bcan{background:#1e3048;color:#e2eaf2}
body.dark .pref{background:#080f18;border-color:#1e3048}
body.dark .pinstr{background:#1a1200;border-color:#3a2800}
body.dark .pm{border-color:#1e3048}
body.dark .pm:hover,.dark .pm.sel{border-color:var(--gold);background:#1a1200}
body.dark .footer{background:#04090f}
body.dark .fbcard{background:#051a10;border-color:#0a3820}
body.dark table{background:#0d1b2a}
body.dark .cbanner{background:linear-gradient(135deg,#00391a,#002810)}
body.dark .dev-tag{color:#0f1923}
body.dark .set-tag{color:#fff}

/* ── FLOATING TOGGLE ───────────────────────────────────── */
.float-toggle{
  position:fixed;bottom:28px;right:28px;z-index:99999;
  width:56px;height:56px;border-radius:50%;border:none;cursor:pointer;pointer-events:auto;
  background:linear-gradient(135deg,#C9991A,#F5C842);
  font-size:24px;display:flex;align-items:center;justify-content:center;
  box-shadow:0 4px 20px rgba(201,153,26,.55);
  transition:transform .25s,box-shadow .25s;
}
.float-toggle:hover{transform:scale(1.15) rotate(20deg);box-shadow:0 8px 32px rgba(201,153,26,.7)}
.float-toggle:active{transform:scale(.92)}
body@keyframes pulse{0%,100%{opacity:1}50%{opacity:.7}}
body.dark .float-toggle{background:linear-gradient(135deg,#1a3050,#263e5a);box-shadow:0 4px 20px rgba(0,0,0,.5)}
.float-label{
  position:fixed;bottom:92px;right:20px;z-index:99998;
  background:var(--ink);color:var(--bg);
  font-size:10px;font-family:'Syne',sans-serif;font-weight:800;
  letter-spacing:.1em;text-transform:uppercase;
  padding:4px 10px;border-radius:100px;
  pointer-events:none;white-space:nowrap;
  opacity:0;transition:opacity .2s;
}
.float-toggle:hover ~ .float-label{opacity:1}

/* ── TOAST ─────────────────────────────────────────────── */
.toast{position:fixed;top:18px;right:18px;z-index:99999;padding:11px 22px;border-radius:8px;
  font-size:14px;font-family:'Syne',sans-serif;font-weight:600;box-shadow:var(--shL);animation:tin .3s ease}
.tok{background:var(--green);color:#fff}.terr{background:var(--red);color:#fff}
@keyframes tin{from{opacity:0;transform:translateX(30px)}to{opacity:1;transform:none}}

/* ── NAVBAR ────────────────────────────────────────────── */
.nav{background:var(--ink);height:62px;display:flex;align-items:center;
  justify-content:space-between;padding:0 24px;position:sticky;top:0;z-index:200;
  box-shadow:0 2px 18px rgba(0,0,0,.22)}
.nbrand{display:flex;align-items:center;gap:10px;cursor:pointer}
.nlogo{width:38px;height:38px;background:linear-gradient(135deg,var(--gold),var(--gold2));
  border-radius:9px;display:flex;align-items:center;justify-content:center;
  font-family:'Syne',sans-serif;font-weight:800;font-size:11px;color:#0f1923}
.nbtext strong{display:block;color:#fff;font-family:'Syne',sans-serif;font-weight:700;font-size:14px}
.nbtext span{font-size:9px;color:rgba(255,255,255,.35);letter-spacing:.12em;font-family:'Syne',sans-serif}
.nlinks{display:flex;align-items:center;gap:6px}
.nb{background:none;border:none;color:rgba(255,255,255,.65);cursor:pointer;padding:7px 13px;
  border-radius:6px;font-family:'Syne',sans-serif;font-size:12px;font-weight:600;
  letter-spacing:.04em;transition:all .18s}
.nb:hover{background:rgba(255,255,255,.09);color:#fff}
.nb-gold{background:var(--gold);color:#0f1923!important;font-weight:700}
.nb-gold:hover{background:var(--gold2)!important}
.nb-out{border:1px solid rgba(255,255,255,.22);color:#fff!important}
.nb-out:hover{border-color:rgba(255,255,255,.6)!important}
.upill{background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.12);
  color:rgba(255,255,255,.65);padding:4px 11px;border-radius:100px;
  font-size:10px;font-family:'Syne',sans-serif;font-weight:700}

/* ── HERO ──────────────────────────────────────────────── */
.hero{min-height:91vh;background:linear-gradient(140deg,#0f1923 0%,#1a3050 55%,#0d2610 100%);
  display:flex;flex-direction:column;align-items:center;justify-content:center;
  text-align:center;padding:72px 24px 56px;position:relative;overflow:hidden}
.hero::before{content:'';position:absolute;inset:0;pointer-events:none;
  background:radial-gradient(ellipse 70% 50% at 50% 0%,rgba(201,153,26,.12),transparent)}
.hero-tag{position:relative;z-index:10;background:rgba(201,153,26,.18);border:1px solid rgba(201,153,26,.4);color:var(--gold2);
  padding:5px 18px;border-radius:100px;font-size:10px;letter-spacing:.16em;text-transform:uppercase;
  font-family:'Syne',sans-serif;font-weight:700;margin-bottom:26px;display:inline-block}
.hero h1{position:relative;z-index:10;font-size:clamp(36px,6vw,68px);color:#fff;line-height:1.08;max-width:800px;margin-bottom:18px}
.hero h1 em{color:var(--gold2);font-style:normal}
.hero-sub{position:relative;z-index:10;font-size:17px;color:rgba(255,255,255,.62);max-width:500px;line-height:1.75;margin-bottom:44px}
.hero-btns{display:flex;gap:14px;flex-wrap:wrap;justify-content:center;margin-bottom:48px;position:relative;z-index:10}
.bprimary{background:var(--gold);color:#0f1923;padding:15px 36px;border-radius:8px;
  font-family:'Syne',sans-serif;font-weight:700;font-size:15px;letter-spacing:.04em;
  border:none;cursor:pointer;box-shadow:0 4px 18px rgba(201,153,26,.4);transition:all .2s}
.bprimary:hover{background:var(--gold2);transform:translateY(-2px);box-shadow:0 6px 24px rgba(201,153,26,.55)}
.bsecond{background:rgba(255,255,255,.08);color:#fff;padding:15px 36px;border-radius:8px;
  font-family:'Syne',sans-serif;font-weight:600;font-size:15px;letter-spacing:.04em;
  border:1.5px solid rgba(255,255,255,.35);cursor:pointer;transition:all .2s;backdrop-filter:blur(4px)}
.bsecond:hover{background:rgba(255,255,255,.15);border-color:rgba(255,255,255,.7)}
.chips{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;position:relative;z-index:10}
.chip{background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.12);
  color:rgba(255,255,255,.58);padding:5px 14px;border-radius:100px;
  font-size:10px;font-family:'Syne',sans-serif;letter-spacing:.04em}

/* ── SECTIONS ──────────────────────────────────────────── */
.sec{padding:80px 24px;max-width:1080px;margin:0 auto}
.slbl{color:var(--gold);font-size:10px;letter-spacing:.18em;text-transform:uppercase;
  font-family:'Syne',sans-serif;font-weight:700;margin-bottom:8px}
.stitle{font-size:clamp(26px,4vw,40px);color:var(--ink);margin-bottom:36px;line-height:1.2}
.stitle em{color:var(--green);font-style:normal}
.bg-w{background:#fff}.bg-ink{background:var(--ink)}
.steps{display:grid;grid-template-columns:repeat(auto-fit,minmax(210px,1fr));gap:20px}
.step{background:var(--card);border:1px solid var(--border);border-radius:var(--r);
  padding:28px 24px;position:relative;transition:box-shadow .2s}
.step:hover{box-shadow:var(--sh)}
.step-n{position:absolute;top:-13px;left:22px;background:var(--ink);color:var(--gold2);
  font-family:'Syne',sans-serif;font-weight:800;font-size:12px;width:28px;height:28px;
  border-radius:50%;display:flex;align-items:center;justify-content:center}
.step-ico{font-size:28px;margin-bottom:12px;margin-top:4px}
.step h3{font-size:15px;color:var(--ink);margin-bottom:7px}
.step p{font-size:13px;color:var(--muted);line-height:1.65}

/* ── VIDEO ─────────────────────────────────────────────── */
.vgrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:18px;margin-top:28px}
.vcard{background:#0d1e2e;border:1px solid rgba(255,255,255,.1);
  border-radius:var(--r);overflow:hidden;transition:transform .2s,box-shadow .2s}
.vcard:hover{transform:translateY(-3px);box-shadow:0 8px 32px rgba(0,0,0,.3)}
.vframe{aspect-ratio:16/9;border:none;width:100%;display:block;background:#060d14;min-height:180px}
.vbody{padding:14px 16px}
.vbody h4{color:#ffffff;font-size:13px;margin-bottom:3px;font-family:'Syne',sans-serif;font-weight:700}
.vbody p{color:rgba(255,255,255,.35);font-size:10px;letter-spacing:.06em;font-family:'Syne',sans-serif}

/* ── DISCLAIMER ────────────────────────────────────────── */
.disc{background:linear-gradient(135deg,#fffcf0,#fff8e1);border-left:4px solid var(--gold);
  border-radius:var(--r);padding:32px 36px;max-width:1080px;margin:0 auto 72px}
.disc h3{color:var(--ink);font-size:18px;margin-bottom:12px}
.disc li{color:#5a4400;font-size:13px;line-height:1.85;margin-bottom:3px}
.disc ul{padding-left:18px}

/* ── FOOTER ────────────────────────────────────────────── */
.footer{background:var(--ink);color:rgba(255,255,255,.32);text-align:center;
  padding:28px 24px;font-size:11px;font-family:'Syne',sans-serif;letter-spacing:.04em}
.footer strong{color:var(--gold2)}

/* ── AUTH ──────────────────────────────────────────────── */
.aw{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:var(--bg)}
.acard{background:var(--card);border:1px solid var(--border);border-radius:16px;padding:44px;
  width:100%;max-width:500px;box-shadow:var(--shL)}
.acard h2{font-size:27px;color:var(--ink);margin-bottom:5px}
.acard .sub{color:var(--muted);font-size:13px;margin-bottom:26px}
.tabs{display:flex;background:#eef0f4;border-radius:8px;padding:4px;margin-bottom:26px}
body.dark .tabs{background:#080f18}
.tab{flex:1;padding:9px;border:none;background:none;border-radius:6px;cursor:pointer;
  font-family:'Syne',sans-serif;font-weight:600;font-size:11px;letter-spacing:.05em;
  text-transform:uppercase;color:var(--muted);transition:all .18s}
.tab.on{background:#fff;color:var(--ink);box-shadow:var(--sh)}
body.dark .tab.on{background:#0d1b2a;color:#e2eaf2}
.fg{margin-bottom:15px}
.fl{display:block;font-size:11px;font-weight:700;font-family:'Syne',sans-serif;
  color:var(--ink2);letter-spacing:.06em;text-transform:uppercase;margin-bottom:5px}
.req{color:var(--red)}
.fi{width:100%;padding:10px 13px;border:1.5px solid var(--border);border-radius:7px;
  font-size:13.5px;color:var(--ink);background:#fff;outline:none;transition:border .18s}
.fi:focus{border-color:var(--ink)}
select.fi{appearance:none;cursor:pointer}
.bauth{width:100%;padding:13px;background:var(--ink);color:#fff;border:none;
  border-radius:8px;font-size:14px;font-weight:700;font-family:'Syne',sans-serif;
  letter-spacing:.05em;text-transform:uppercase;cursor:pointer;margin-top:6px;transition:background .18s}
.bauth:hover{background:var(--ink2)}
.bauth.gold{background:var(--gold);color:#0f1923}
.bauth.gold:hover{background:var(--gold2)}
.tcol2{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.aswitch{text-align:center;margin-top:18px;font-size:12px;color:var(--muted)}
.aswitch button{background:none;border:none;color:var(--ink2);cursor:pointer;
  font-weight:700;font-family:'Syne',sans-serif;font-size:12px}
.rid{display:inline-flex;align-items:center;gap:5px;background:var(--green2);color:var(--green);
  padding:2px 9px;border-radius:100px;font-size:10px;font-family:'Syne',sans-serif;font-weight:700}

/* ── FORM ──────────────────────────────────────────────── */
.fpage{max-width:840px;margin:0 auto;padding:36px 24px 80px}
.fhd{background:linear-gradient(135deg,var(--ink),var(--ink2));border-radius:12px 12px 0 0;padding:26px 32px}
.fhd h2{font-size:19px;color:#fff}.fhd p{font-size:12px;color:rgba(255,255,255,.5);margin-top:4px}
.fbody{background:var(--card);border:1px solid var(--border);border-top:none;
  border-radius:0 0 12px 12px;padding:32px}
.fsec{font-size:12px;color:var(--ink2);font-family:'Syne',sans-serif;font-weight:700;
  letter-spacing:.07em;text-transform:uppercase;margin:26px 0 14px;padding-bottom:8px;
  border-bottom:2px solid var(--border);display:flex;align-items:center;gap:8px}
.fsec::before{content:'';width:3px;height:14px;background:var(--gold);border-radius:2px;flex-shrink:0}
.f2{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.s2{grid-column:span 2}
.rgrp{display:flex;gap:20px;margin-top:8px}
.rl{display:flex;align-items:center;gap:7px;cursor:pointer;font-size:13.5px}
.rl input{accent-color:var(--ink);cursor:pointer}
.ckl{display:flex;align-items:flex-start;gap:9px;font-size:13px;cursor:pointer;line-height:1.65}
.ckl input{accent-color:var(--ink);cursor:pointer;margin-top:3px;flex-shrink:0}
.ctbl{width:100%;border-collapse:collapse;margin-top:8px}
.ctbl th{background:#f5f4f0;padding:9px 11px;text-align:left;font-size:10px;font-weight:700;
  font-family:'Syne',sans-serif;color:var(--muted);letter-spacing:.07em;text-transform:uppercase;border:1px solid var(--border)}
.ctbl td{padding:7px 8px;border:1px solid var(--border)}
.ctbl td input{width:100%;border:none;outline:none;font-size:13px;background:transparent;font-family:'Lora',serif}
.declbox{background:#f8f8f5;border:1px solid var(--border);border-radius:8px;
  padding:16px 18px;font-size:13px;color:var(--muted);line-height:1.85;margin-top:6px}
.upbox{border:2px dashed var(--border);border-radius:8px;padding:22px;text-align:center;cursor:pointer;transition:all .2s}
.upbox:hover{border-color:var(--ink2);background:#f5f8ff}
.upbox p{font-size:13px;color:var(--muted)}.upbox .ok{color:var(--green);font-weight:600}
.flist{margin-top:12px;display:flex;flex-direction:column;gap:6px}
.fitem{display:flex;align-items:center;justify-content:space-between;background:var(--green2);
  border:1px solid #b3dfc5;border-radius:6px;padding:7px 12px;font-size:12.5px}
.fitem span{color:var(--green);font-weight:600;font-family:'Syne',sans-serif}
.fitem button{background:none;border:none;color:var(--red);cursor:pointer;font-size:15px;padding:0 2px;line-height:1}
.fadd{display:inline-flex;align-items:center;gap:6px;margin-top:10px;padding:7px 16px;
  background:var(--card);border:1.5px dashed var(--border);border-radius:6px;
  font-size:12px;color:var(--ink2);cursor:pointer;font-family:'Syne',sans-serif;font-weight:600;transition:all .18s}
.fadd:hover{border-color:var(--ink2);background:#f5f8ff}
.fact{display:flex;justify-content:flex-end;gap:10px;margin-top:28px;padding-top:22px;border-top:1px solid var(--border)}
.bsub{padding:12px 34px;background:var(--green);color:#fff;border:none;border-radius:8px;
  font-size:13px;font-weight:700;font-family:'Syne',sans-serif;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;transition:background .18s}
.bsub:hover{background:#005030}
.bcan{padding:12px 22px;background:#eeece8;color:var(--ink);border:none;border-radius:8px;
  font-size:12px;font-weight:600;font-family:'Syne',sans-serif;cursor:pointer}

/* ── PAYMENT ───────────────────────────────────────────── */
.pw{min-height:90vh;display:flex;align-items:center;justify-content:center;padding:24px}
.pcard{background:var(--card);border-radius:16px;padding:44px;max-width:460px;width:100%;box-shadow:var(--shL);text-align:center}
.pamt{font-size:56px;font-family:'Syne',sans-serif;font-weight:800;color:var(--ink);margin:14px 0}
.pamt span{font-size:22px;color:var(--muted)}
.pmethods{display:flex;flex-direction:column;gap:9px;margin:22px 0}
.pm{padding:13px 18px;border:1.5px solid var(--border);border-radius:8px;cursor:pointer;
  display:flex;align-items:center;gap:12px;font-size:13px;transition:all .18s;
  text-align:left;background:none;width:100%}
.pm:hover,.pm.sel{border-color:var(--gold);background:var(--gold-bg)}
.pref{background:#f5f8ff;padding:10px 15px;border-radius:8px;font-size:12.5px;
  color:var(--muted);margin-bottom:16px;border:1px dashed var(--border)}
.pref strong{color:var(--ink2);display:block;font-family:'Syne',sans-serif;font-size:10px;margin-bottom:2px;letter-spacing:.06em;text-transform:uppercase}
.pinstr{background:var(--gold-bg);border:1px solid #e8d88a;border-radius:8px;
  padding:13px 16px;margin-bottom:16px;font-size:13px;text-align:left;color:#5a4000}

/* ── DASHBOARD ─────────────────────────────────────────── */
.dash{max-width:920px;margin:0 auto;padding:40px 24px 80px}
.dash-hd h2{font-size:29px;color:var(--ink)}.dash-hd p{color:var(--muted);font-size:13px;margin-top:4px;margin-bottom:24px}
.icard{background:var(--card);border:1px solid var(--border);border-radius:var(--r);padding:22px 26px;margin-bottom:18px;box-shadow:var(--sh)}
.igrid{display:grid;grid-template-columns:repeat(auto-fit,minmax(155px,1fr));gap:14px}
.ii .lbl{font-size:9px;text-transform:uppercase;letter-spacing:.1em;color:var(--muted);font-family:'Syne',sans-serif;font-weight:700;margin-bottom:3px}
.ii .val{font-size:13.5px;color:var(--ink);font-weight:500}
.tl-step{display:flex;gap:14px;align-items:flex-start;margin-bottom:20px;position:relative}
.tl-step:not(:last-child)::after{content:'';position:absolute;left:14px;top:32px;bottom:-20px;width:2px;background:var(--border)}
.tldot{width:30px;height:30px;border-radius:50%;border:2px solid var(--border);background:var(--card);
  display:flex;align-items:center;justify-content:center;font-size:12px;flex-shrink:0;z-index:1}
.tldot.done{background:var(--green);border-color:var(--green);color:#fff}
.tldot.active{background:var(--ink);border-color:var(--ink);color:#fff}
.tl-content h4{font-size:14px;color:var(--ink);margin-bottom:2px}
.tl-content p{font-size:12px;color:var(--muted)}
.cbanner{background:linear-gradient(135deg,#006B3F,#005030);color:#fff;border-radius:var(--r);
  padding:22px 26px;margin-bottom:18px;display:flex;align-items:center;gap:16px}
.cbanner h3{font-size:18px;margin-bottom:4px}.cbanner p{font-size:13px;opacity:.8;line-height:1.65}
.fbcard{background:#f0faf4;border:1px solid #b3dfc5;border-radius:7px;padding:13px 16px;margin-top:9px}
.fbcard h4{font-size:11px;color:var(--green);font-family:'Syne',sans-serif;font-weight:700;letter-spacing:.05em;margin-bottom:4px}
.fbcard p{font-size:13px;color:var(--muted)}
.sbadge{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;border-radius:100px;
  font-size:10px;font-weight:700;font-family:'Syne',sans-serif;letter-spacing:.05em}
.s-submitted{background:#e8f0fe;color:#1a56db}.s-payment_pending{background:#fff3e0;color:#e65100}
.s-paid{background:#e6f4ea;color:#137333}.s-forwarded_to_settlers{background:#e8f0fe;color:#1558d6}
.s-processing{background:#fce8e6;color:#c5221f}.s-completed{background:#e6f4ea;color:#137333}

/* ── DEV DASHBOARD ─────────────────────────────────────── */
.devdash{max-width:1080px;margin:0 auto;padding:36px 24px 80px}
.dev-tag{background:var(--gold);color:#0f1923;font-size:10px;font-weight:800;font-family:'Syne',sans-serif;letter-spacing:.1em;text-transform:uppercase;padding:3px 10px;border-radius:100px;display:inline-block;margin-bottom:10px}
.srow{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:14px;margin-bottom:26px}
.scard{background:var(--card);border:1px solid var(--border);border-radius:var(--r);padding:18px 22px}
.scard .num{font-size:30px;font-family:'Syne',sans-serif;font-weight:800;color:var(--ink)}
.scard .lbl{font-size:10px;color:var(--muted);margin-top:2px;font-family:'Syne',sans-serif;letter-spacing:.05em;text-transform:uppercase}
.abox{background:var(--card);border:1px solid var(--border);border-radius:var(--r);overflow:hidden}
.abox-hd{padding:15px 22px;border-bottom:1px solid var(--border);display:flex;justify-content:space-between;align-items:center}
.abox-hd h3{font-size:16px;color:var(--ink)}
table{width:100%;border-collapse:collapse}
thead th{background:#f5f4f0;padding:9px 13px;text-align:left;font-size:9px;font-weight:700;
  font-family:'Syne',sans-serif;color:var(--muted);text-transform:uppercase;letter-spacing:.1em;border-bottom:1px solid var(--border)}
tbody td{padding:11px 13px;font-size:12.5px;border-bottom:1px solid #f0ede8;vertical-align:middle}
tbody tr:last-child td{border-bottom:none}
tbody tr:hover td{background:#fafaf8}
.abtn{padding:4px 11px;border-radius:5px;font-size:10px;font-weight:700;cursor:pointer;border:none;
  font-family:'Syne',sans-serif;letter-spacing:.05em;text-transform:uppercase;transition:all .18s;margin-right:4px}
.ab-v{background:#f0f0ee;color:#444}.ab-v:hover{background:#ddd}
.ab-f{background:#e8f0fe;color:#1558d6}.ab-f:hover{background:#1558d6;color:#fff}
.ab-c{background:var(--green2);color:var(--green)}.ab-c:hover{background:var(--green);color:#fff}
.vmgr{background:var(--card);border:1px solid var(--border);border-radius:var(--r);padding:22px 26px;margin-top:22px}
.vmgr h3{font-size:16px;color:var(--ink);margin-bottom:13px}
.vadd{display:flex;gap:9px;margin-bottom:14px;flex-wrap:wrap}
.vadd .fi{flex:1;min-width:150px}
.vitem{display:flex;justify-content:space-between;align-items:center;background:#f8f8f5;
  padding:9px 13px;border-radius:6px;font-size:12px;margin-bottom:6px}
.vitem .vt{font-weight:700;color:var(--ink2);font-family:'Syne',sans-serif;font-size:11px}
.brm{background:none;border:none;color:var(--red);cursor:pointer;font-size:16px;padding:2px 4px}

/* ── SETTLERS ──────────────────────────────────────────── */
.setdash{max-width:1080px;margin:0 auto;padding:36px 24px 80px}
.set-tag{background:var(--green);color:#fff;font-size:10px;font-weight:800;font-family:'Syne',sans-serif;
  letter-spacing:.1em;text-transform:uppercase;padding:3px 10px;border-radius:100px;display:inline-block;margin-bottom:10px}
.setcard{background:var(--card);border:1px solid var(--border);border-radius:var(--r);padding:22px 26px;margin-bottom:16px;box-shadow:var(--sh)}
.setcard textarea{width:100%;padding:10px 13px;border:1.5px solid var(--border);border-radius:7px;
  font-size:13px;font-family:'Lora',serif;resize:vertical;min-height:66px;outline:none;background:var(--card);color:var(--ink)}
.setcard textarea:focus{border-color:var(--ink)}
.setacts{display:flex;gap:8px;margin-top:9px;flex-wrap:wrap}
.bset{padding:7px 18px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;border:none;
  font-family:'Syne',sans-serif;letter-spacing:.05em;text-transform:uppercase;transition:all .18s}
.bproc{background:#fce8e6;color:#c5221f}.bproc:hover{background:#c5221f;color:#fff}

/* ── MODAL ─────────────────────────────────────────────── */
.movo{position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1000;
  display:flex;align-items:center;justify-content:center;padding:24px}
.modal{background:var(--card);border-radius:14px;padding:32px;max-width:660px;width:100%;
  max-height:88vh;overflow-y:auto;box-shadow:var(--shL)}
.mhd{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:20px}
.mhd h3{font-size:21px;color:var(--ink)}
.mclose{background:none;border:none;font-size:20px;cursor:pointer;color:var(--muted)}
.dg{display:grid;grid-template-columns:1fr 1fr;gap:11px;margin-bottom:16px}
.di .dl{font-size:9px;text-transform:uppercase;letter-spacing:.1em;color:var(--muted);
  font-family:'Syne',sans-serif;font-weight:700;margin-bottom:2px}
.di .dv{font-size:13px;color:var(--ink)}
.sdiv{font-size:11px;font-weight:700;font-family:'Syne',sans-serif;color:var(--ink2);
  text-transform:uppercase;letter-spacing:.09em;margin:14px 0 10px;padding-bottom:6px;border-bottom:1px solid var(--border)}

@media(max-width:640px){
  .vgrid{grid-template-columns:1fr !important}
  .vcard{max-width:100%}
  .f2,.tcol2,.dg{grid-template-columns:1fr}.s2{grid-column:span 1}
  .nav{padding:0 14px}.nbtext{display:none}.vadd{flex-direction:column}
  .hero-btns{flex-direction:column;align-items:center}
  .bprimary,.bsecond{width:100%;max-width:300px}
}

`;

const ADMIN_ACCTS = [
  { id:"dev_001", email:"Amisco4u2", password:"Amiena702$", role:"developer", name:"Developer Admin", region:"Greater Accra", town:"Accra", occupation:"Developer" },
  { id:"set_001", email:"Dinto", password:"Ventures", role:"settlers", name:"Settlers Agent", region:"Greater Accra", town:"Accra", occupation:"Agent" },
];

const DEFAULT_VIDEOS = [
  { title:"Understanding Tax Relief in Ghana",   url:"https://youtu.be/WotyDSoOIms", type:"youtube" },
  { title:"How to Claim Your Employment Relief", url:"https://youtu.be/1eoyWz3MR_I", type:"youtube" },
  { title:"Marriage & Family Relief Benefits",   url:"https://youtu.be/FKY9cqulkhs", type:"youtube" },
  { title:"Disability & Old Age Relief Guide",   url:"https://youtu.be/2gsGXy9e8oY", type:"youtube" },
  { title:"Children Education Relief Explained", url:"https://youtu.be/XtXNMPa5nuE", type:"youtube" },
];

const GH_REGIONS = ["Greater Accra","Ashanti","Western","Central","Eastern","Volta","Oti","Bono","Bono East","Ahafo","Northern","Savannah","North East","Upper East","Upper West","Western North"];

const GH_TOWNS = {
  "Greater Accra": ["Accra","Tema","Madina","Kasoa","Ashaiman","Teshie","Nungua","Adenta","Dome","Achimota","Osu","Labadi","Dansoman","Kaneshie","Lapaz","Spintex","Prampram","Dodowa","Amasaman","Weija"],
  "Ashanti": ["Kumasi","Obuasi","Ejisu","Konongo","Mampong","Bekwai","Asante Mampong","Juaben","Agogo","Kenyasi","Mankranso","Tepa","Jacobu","Nkawie","Offinso","Atwima","Ahinsan","Asokwa","Suame","Tafo"],
  "Western": ["Sekondi","Takoradi","Tarkwa","Axim","Prestea","Bogoso","Nkroful","Agona Nkwanta","Asankrangwa","Enchi","Bibiani","Sefwi Wiawso","Juaboso","Bia","Half Assini","Jomoro","Ellembelle","Shama","Mpohor","Ahanta West"],
  "Central": ["Cape Coast","Winneba","Kasoa","Mankessim","Elmina","Assin Fosu","Agona Swedru","Saltpond","Mumford","Anomabo","Breman Asikuma","Twifo Praso","Dunkwa","Awutu Bereku","Gomoa Fetteh","Effutu","Abura Dunkwa","Ajumako","Asikuma Odoben","Hemang"],
  "Eastern": ["Koforidua","Nkawkaw","Suhum","Nsawam","Asamankese","Oda","Akropong","Somanya","Kade","Mpraeso","Akim Oda","Akim Tafo","Akwatia","Aburi","Kumasi","Jumapo","Ofoase","Begoro","Atibie","Kwahu Praso"],
  "Volta": ["Ho","Hohoe","Keta","Aflao","Akatsi","Kpando","Dambai","Jasikan","Nkwanta","Sogakope","Anloga","Battor","Adidome","Dabala","Alavanyo","Dzodze","Aveyime","Weta","Agbozume","Afadzato"],
  "Oti": ["Dambai","Nkwanta","Jasikan","Kpassa","Chinderi","Asato","Kadjebi","Buem","Worawora","Kpando"],
  "Bono": ["Sunyani","Techiman","Berekum","Dormaa Ahenkro","Wenchi","Brong Ahafo","Jaman North","Jaman South","Tain","Banda"],
  "Bono East": ["Techiman","Kintampo","Nkoranza","Atebubu","Pru","Sene East","Sene West","Techiman North"],
  "Ahafo": ["Goaso","Kukuom","Acherensua","Tepa","Hwidiem","Kenyasi","Duayaw Nkwanta","Mim"],
  "Northern": ["Tamale","Savelugu","Yendi","Gushegu","Karaga","Nanton","Tolon","Kumbungu","Sagnarigu","Mion","Nanumba North","Nanumba South","Zabzugu","Chereponi"],
  "Savannah": ["Damongo","Bole","Sawla","Salaga","East Gonja","West Gonja","Sawla-Tuna-Kalba","North Gonja"],
  "North East": ["Nalerigu","Walewale","Gambaga","Bunkpurugu","Yunyoo","Chereponi","East Mamprusi","West Mamprusi"],
  "Upper East": ["Bolgatanga","Bawku","Navrongo","Zebilla","Bongo","Paga","Sandema","Chiana","Garu","Tempane","Binduri","Builsa North","Builsa South","Kassena Nankana"],
  "Upper West": ["Wa","Lawra","Nandom","Jirapa","Tumu","Nadowli","Daffiama","Birifu","Funsi","Sissala East","Sissala West"],
  "Western North": ["Sefwi Wiawso","Bibiani","Juaboso","Bia East","Bia West","Akontombra","Sui","Anhwiaso","Sefwi Akontombra"],
};
const SECTORS = ["Ghana Police Service","Ghana Education Service (Teachers)","Ghana National Fire Service","Ghana Armed Forces (Military)","Ghana Health Service","Ghana Immigration Service","Judicial Service","Civil Service","Ghana Revenue Authority (GRA)","Ghana Prison Service","Customs Division","Veterinary Service","Statistical Service","Other Government Agency"];
const STATUS_STEPS = [
  {key:"submitted",         label:"Application Submitted",    ico:"📋", desc:"Your form has been received and is awaiting payment."},
  {key:"payment_pending",   label:"Payment Submitted",         ico:"💳", desc:"Your payment details have been submitted. Awaiting admin approval."},
  {key:"awaiting_approval", label:"Awaiting Payment Approval", ico:"⏳", desc:"Admin is verifying your transaction. You will be notified once approved."},
  {key:"approved",          label:"Payment Approved ✅",       ico:"✅", desc:"Your payment has been confirmed. Your application is now being reviewed."},
  {key:"processing",        label:"Under Processing",          ico:"⚙️", desc:"Settlers agent is actively processing your application."},
  {key:"completed",         label:"Application Completed",    ico:"🎉", desc:"Your application has been successfully processed and submitted to GRA."},
];

function getYouTubeId(url){
  // handles youtu.be/ID and youtube.com/watch?v=ID and youtube.com/embed/ID
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
}

function VideoCard({v}){
  const ytId = getYouTubeId(v.url || "");
  const isYT  = !!ytId;

  // Google Drive fallback (kept for any existing drive links)
  const getDriveId = (url) => { const m=url.match(/\/d\/([a-zA-Z0-9_-]{25,})/); return m?m[1]:null; };
  const driveId = !isYT ? getDriveId(v.url||"") : null;

  // YouTube embed URL — autoplay=0 so it just shows the player ready to play
  const ytEmbed = isYT
    ? `https://www.youtube.com/embed/${ytId}?rel=0&modestbranding=1&playsinline=1`
    : null;

  return(
    <div className="vcard" style={{overflow:"hidden",borderRadius:10}}>
      {isYT ? (
        /* ── YOUTUBE: works on ALL devices, loads thumbnail automatically ── */
        <div style={{position:"relative",width:"100%",paddingTop:"56.25%"}}>
          <iframe
            style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
            src={ytEmbed}
            title={v.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            loading="lazy"
          />
        </div>
      ) : driveId ? (
        /* ── GOOGLE DRIVE fallback ── */
        <div style={{position:"relative",width:"100%",paddingTop:"56.25%"}}>
          <iframe
            style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none",background:"#060d14"}}
            src={`https://drive.google.com/file/d/${driveId}/preview`}
            allow="autoplay"
            allowFullScreen
            loading="lazy"
            title={v.title}
          />
        </div>
      ) : (
        /* ── DIRECT URL fallback (Firebase Storage mp4 etc) ── */
        <video controls playsInline preload="metadata"
          style={{width:"100%",aspectRatio:"16/9",background:"#000",display:"block"}}>
          <source src={v.url} type="video/mp4"/>
        </video>
      )}
      <div className="vbody">
        <h4>{v.title}</h4>
        <p style={{fontSize:10,color:"rgba(255,255,255,.4)",fontFamily:"Syne,sans-serif",letterSpacing:".06em"}}>
          TAXRELIEFGH · SETTLERS GH
        </p>
      </div>
    </div>
  );
}

const dbH={
  // ── USERS — saved at /users/username ──────────────────────────────────
  async setUser(u){
    try{
      const key=u.username.toLowerCase();
      await set(dbRef(db,`users/${key}`),u);
    }catch(e){console.error("setUser:",e);}
  },
  async getUser(uname){
    try{
      const snap=await get(child(dbRef(db),`users/${uname.toLowerCase()}`));
      return snap.exists()?snap.val():null;
    }catch(e){console.error("getUser:",e);return null;}
  },

  // ── APPLICATIONS — saved at /applications/appId ───────────────────────
  async setApp(a){
    try{await set(dbRef(db,`applications/${a.id}`),a);}
    catch(e){console.error("setApp:",e);}
  },
  async deleteApp(id){
    try{
      await remove(dbRef(db,`applications/${id}`));
    }catch(e){console.error("deleteApp:",e);}
  },
  // Partial update — only overwrites provided fields
  async updateApp(id,fields){
    try{
      const snap=await get(child(dbRef(db),`applications/${id}`));
      if(!snap.exists())return;
      await set(dbRef(db,`applications/${id}`),{...snap.val(),...fields});
    }catch(e){console.error("updateApp:",e);}
  },
  async getAllApps(){
    try{
      const snap=await get(child(dbRef(db),"applications"));
      if(!snap.exists())return[];
      return Object.values(snap.val());
    }catch(e){console.error("getAllApps:",e);return[];}
  },

  // ── VIDEOS — saved at /settings/videos ───────────────────────────────
  async setVids(v){
    try{await set(dbRef(db,"settings/videos"),v);}
    catch(e){console.error("setVids:",e);}
  },
  async getVids(){
    try{
      const snap=await get(child(dbRef(db),"settings/videos"));
      return snap.exists()?snap.val():null;
    }catch(e){console.error("getVids:",e);return null;}
  },

  // ── DRIVE SCRIPT URL — stored globally so all clients use it ──────────
  async setDriveUrl(url){
    try{await set(dbRef(db,"settings/driveUrl"),url);}
    catch(e){console.error("setDriveUrl:",e);}
  },
  async getDriveUrl(){
    try{
      const snap=await get(child(dbRef(db),"settings/driveUrl"));
      return snap.exists()?snap.val():"";
    }catch(e){console.error("getDriveUrl:",e);return "";}
  },

  // ── FILE DATA — stored at /uploads/{appId}/{index} ──────────────────
  // Files stored as single data string (images compressed to <300KB by client)
  async saveFile(appId,index,fileObj){
    try{
      if(fileObj.driveUrl){
        await set(dbRef(db,`uploads/${appId}/${index}`),{
          name:fileObj.name,type:fileObj.type||"",
          driveUrl:fileObj.driveUrl,viewUrl:fileObj.viewUrl||fileObj.driveUrl,driveId:fileObj.driveId||""
        });
        return true;
      }
      const data=fileObj.data||"";
      if(!data){return false;}
      await set(dbRef(db,`uploads/${appId}/${index}`),{
        name:fileObj.name,type:fileObj.type||"",data
      });
      return true;
    }catch(e){console.error("saveFile:",e.message);return false;}
  },
  async getFiles(appId){
    try{
      const snap=await get(child(dbRef(db),`uploads/${appId}`));
      if(!snap.exists())return[];
      const val=snap.val();
      return Object.keys(val).sort((a,b)=>Number(a)-Number(b)).map(k=>{
        const f=val[k];if(!f)return null;
        if(f.driveUrl){
          const id=f.driveId||(f.driveUrl.match(/id=([^&]+)/)||[])[1]||"";
          const dl=id?`https://drive.google.com/uc?export=download&id=${id}`:f.driveUrl;
          const vw=id?`https://drive.google.com/file/d/${id}/view`:f.viewUrl||f.driveUrl;
          return{name:f.name,type:f.type||"",driveUrl:dl,viewUrl:vw,driveId:id};
        }
        // legacy chunk format
        if(f.chunks){const d=Object.keys(f.chunks).sort((a,b)=>Number(a)-Number(b)).map(c=>f.chunks[c]).join("");return{name:f.name,type:f.type||"",data:d};}
        if(f.data)return{name:f.name,type:f.type||"",data:f.data};
        return null;
      }).filter(f=>f&&(f.data||f.driveUrl));
    }catch(e){console.error("getFiles:",e);return[];}
  }
,

  // ── SESSION — localStorage (free, works on device) ───────────────────
  async setSess(u){
    try{localStorage.setItem("trgh_sess",JSON.stringify(u));}catch(e){}
  },
  async getSess(){
    try{const s=localStorage.getItem("trgh_sess");return s?JSON.parse(s):null;}catch(e){return null;}
  },
  async clearSess(){
    try{localStorage.removeItem("trgh_sess");}catch(e){}
  },
};

// ═══════════════════════════════════════════════════════════════════════════
// APP
// ═══════════════════════════════════════════════════════════════════════════
export default function App(){
  const [page,setPage]=useState("home");
  const [user,setUser]=useState(null);
  const [apps,setApps]=useState([]);
  const [videos,setVids]=useState(DEFAULT_VIDEOS);
  const [toast,setToast]=useState(null);
  const [modal,setModal]=useState(null);
  const [fbText,setFbText]=useState({});
  const [ready,setReady]=useState(false);
  const [dark,setDark]=useState(()=>{try{return localStorage.getItem("trgh_theme")==="dark";}catch(e){return false;}});
  const [fontZoom,setFontZoom]=useState(()=>{try{return parseFloat(localStorage.getItem("trgh_fontzoom")||"1");}catch(e){return 1;}});
  const [showFontPanel,setShowFontPanel]=useState(false);

  useEffect(()=>{
    document.body.classList.toggle("dark",dark);
    document.getElementById("trgh-root") && (document.getElementById("trgh-root").style.zoom = fontZoom);
    try{localStorage.setItem("trgh_fontzoom",fontZoom);localStorage.setItem("trgh_theme",dark?"dark":"light");}catch(e){}
  },[dark]);

  useEffect(()=>{
    (async()=>{
      const sv=await dbH.getVids();
      if(sv && sv.length>0){
        const hasOldDrive=sv.some(v=>v.url&&v.url.includes("drive.google"));
        if(hasOldDrive){
          await dbH.setVids(DEFAULT_VIDEOS);
          setVids(DEFAULT_VIDEOS);
        } else {
          setVids(sv);
        }
      } else {
        await dbH.setVids(DEFAULT_VIDEOS);
        setVids(DEFAULT_VIDEOS);
      }
      const sa=await dbH.getAllApps();if(sa.length)setApps(sa);
      const ss=await dbH.getSess();if(ss)setUser(ss);
      // Load Drive URL from Firebase — works on ALL browsers (client + admin)
      const du=await dbH.getDriveUrl();
      if(du){window.__GDRIVE_SCRIPT_URL__=du;}
      else{const loc=localStorage.getItem("trgh_gdrive_url");if(loc)window.__GDRIVE_SCRIPT_URL__=loc;}
      setReady(true);
      // ── Hubtel payment return detection ─────────────────────────────────
      const urlParams=new URLSearchParams(window.location.search);
      const hubtelStatus=urlParams.get("hubtel");
      const hubtelRef=urlParams.get("clientReference")||urlParams.get("ref")||"";
      if(hubtelStatus==="success"||hubtelStatus==="paid"){
        // Clean URL
        window.history.replaceState({},"",window.location.pathname);
        // Confirm payment automatically
        if(ss){
          const allApps=await dbH.getApps();
          const pending=allApps.find(a=>a.userId===ss.id&&(a.status==="submitted"||a.status==="payment_pending"));
          if(pending){
            const ref=hubtelRef||urlParams.get("transactionId")||"HUBTEL-AUTO";
            // Payment verified by Hubtel — skip awaiting_approval, go straight to approved
            const upd={
              ...pending,
              status:"approved",
              transactionId:ref,
              paymentMethod:"hubtel",
              hubtelReference:ref,
              paymentSubmittedAt:new Date().toISOString(),
              approvedAt:new Date().toISOString(),
              paymentVerified:true,
              autoApproved:true
            };
            await dbH.setApp(upd);
            // SMS: payment confirmed + auto-approved
            sendSMS(ss?.phone, `TaxReliefGH: Payment of GH₵200 confirmed & your application ${pending.id} has been APPROVED automatically. Our team will now process your tax relief. Login to track progress.`);
          }
        }
      }
    })();
  },[]);

  const toast_=(msg,type="ok")=>{setToast({msg,type});setTimeout(()=>setToast(null),4000);};

  const goAuth=()=>setPage("auth");

  const login=async(uname,pw)=>{
    // Admin accounts match exact case
    const adm=ADMIN_ACCTS.find(a=>a.email===uname&&a.password===pw);
    if(adm){await dbH.setSess(adm);setUser(adm);setPage(adm.role==="developer"?"dev_dashboard":"settlers_dashboard");toast_(`Welcome, ${adm.name}!`);return;}
    // getUser auto-lowercases the key so any case works at login
    const u=await dbH.getUser(uname); // works regardless of caps
    if(!u||u.password!==pw){toast_("Invalid username or password.","err");return;}
    await dbH.setSess(u);setUser(u);
    const ua=apps.find(a=>a.userId===u.id);
    setPage(ua?"customer_dashboard":"form");
    toast_(`Welcome back, ${u.name.split(" ")[0]}!`);
  };

  const register=async(d)=>{
    const usernameTyped=d.username.trim();
    if(!usernameTyped||usernameTyped.length<3){toast_("Username must be at least 3 characters.","err");return;}
    const exists=await dbH.getUser(usernameTyped); // getUser auto-lowercases key
    if(exists){toast_("Username already taken. Try another.","err");return;}
    const u={...d,username:usernameTyped,id:`TRG-${d.region.slice(0,3).toUpperCase()}-${Date.now().toString().slice(-5)}`,role:"customer"};
    await dbH.setUser(u);await dbH.setSess(u);setUser(u);setPage("form");
    toast_("Account created! Fill your application below.");
  };

  const logout=async()=>{await dbH.clearSess();setUser(null);setPage("home");toast_("Signed out.");};

  const submitForm=async(data)=>{
    const appId=`APP-${Date.now()}`;
    // Save files separately in /uploads/{appId}/ — keeps app doc small
    const fileMeta=[];
    if(data.attachedFiles&&data.attachedFiles.length>0){
      for(let i=0;i<data.attachedFiles.length;i++){
        const f=data.attachedFiles[i];
        if(f&&f.data){
          const ok=await dbH.saveFile(appId,i,f);
          console.log(`File ${i} (${f.name}): saved=${ok}, size=${Math.round(f.data.length/1024)}KB`);
          fileMeta.push({name:f.name,type:f.type||"",index:i,saved:ok});
        } else if(f&&f.name){
          fileMeta.push({name:f.name,type:f.type||"",index:i,saved:false});
        }
      }
    }
    // Store app WITHOUT file data (just metadata references)
    const cleanData={...data,attachedFiles:fileMeta};
    const a={id:appId,userId:user.id,userName:user.name,userEmail:user.email,
      userRegion:user.region,userTown:user.town,userOccupation:user.occupation,userUsername:user.username||"",
      sector:data.sector,data:cleanData,fileCount:fileMeta.length,
      status:"submitted",submittedAt:new Date().toISOString(),feedbacks:[]};
    await dbH.setApp(a);setApps(p=>[...p,a]);setPage("payment");
    toast_("Application submitted! Please complete payment.");
  };

  // Allow client to edit application if still submitted/awaiting
  const editApp=()=>{
    const app=apps.find(a=>a.userId===user.id);
    if(!app){toast_("No application found.");return;}
    if(!["submitted","awaiting_approval"].includes(app.status)){
      toast_("Application can only be edited before payment is approved.");return;
    }
    setPage("form");
  };

  // Save edits back to Firebase
  const saveEditedApp=async(data)=>{
    const existing=apps.find(a=>a.userId===user.id);
    if(!existing){await submitForm(data);return;}
    const fileMeta=[];
    if(data.attachedFiles&&data.attachedFiles.length>0){
      for(let i=0;i<data.attachedFiles.length;i++){
        const fl=data.attachedFiles[i];
        if(!fl)continue;
        if(fl.driveUrl){
          // Already on Google Drive — keep reference, re-save to Firebase index
          await dbH.saveFile(existing.id,i,fl);
          fileMeta.push({name:fl.name,type:fl.type||"",index:i,driveUrl:fl.driveUrl,viewUrl:fl.viewUrl||fl.driveUrl});
        } else if(fl.data){
          // Has base64 data — save/overwrite in Firebase /uploads/
          const ok=await dbH.saveFile(existing.id,i,fl);
          fileMeta.push({name:fl.name,type:fl.type||"",index:i,saved:ok});
        } else if(fl.name){
          // Metadata only (legacy) — keep reference
          fileMeta.push({name:fl.name,type:fl.type||"",index:i});
        }
      }
    }
    const cleanData={...data,attachedFiles:fileMeta};
    const updated={...existing,data:cleanData,fileCount:fileMeta.length,lastEdited:new Date().toISOString()};
    await dbH.setApp(updated);
    setApps(p=>p.map(a=>a.id===existing.id?updated:a));
    toast_("✅ Application updated successfully!");
    setPage("customer_dashboard");
  };

  // Refresh apps from Firebase — called when dashboard loads
  const refreshApps=async()=>{
    const all=await dbH.getAllApps();
    if(all)setApps(all);
  };

  const confirmPayment=async(transactionId,method,hubtelRef)=>{
    const updated=apps.map(a=>{
      if(a.userId===user.id&&(a.status==="submitted"||a.status==="payment_pending")){
        const u={...a,
          status:"awaiting_approval",
          transactionId:transactionId||hubtelRef||"",
          paymentMethod:method||"hubtel",
          hubtelReference:hubtelRef||"",
          paymentSubmittedAt:new Date().toISOString(),
          paymentVerified:!!hubtelRef
        };
        dbH.setApp(u);
        return u;
      }return a;
    });
    setApps(updated);setPage("customer_dashboard");
    toast_(hubtelRef?"✅ Payment confirmed via Hubtel!":"Payment submitted! We will verify and approve shortly.");
  };

  const approvePayment=async(id)=>{
    const updated=apps.map(a=>{if(a.id===id){const u={...a,status:"approved",approvedAt:new Date().toISOString()};dbH.setApp(u);return u;}return a;});
    setApps(updated);
    toast_("Payment approved! Client notified.");
  }

  // Developer: delete any application
  const deleteApp=async(id)=>{
    if(!window.confirm("Delete this application permanently? This cannot be undone."))return;
    await dbH.deleteApp(id);
    setApps(p=>p.filter(a=>a.id!==id));
    toast_("🗑️ Application deleted.");
  };

  // Developer: save edited application data back to Firebase
  const devSaveEdit=async(appId, newData)=>{
    const updated=apps.map(a=>{
      if(a.id===appId){
        const u={...a,data:{...a.data,...newData},lastEditedByDev:new Date().toISOString()};
        dbH.setApp(u);
        return u;
      }
      return a;
    });
    setApps(updated);
    toast_("✅ Application updated by developer.");
  };;

  const forward=async(id)=>{
    const updated=apps.map(a=>{if(a.id===id){const u={...a,status:"processing",forwardedAt:new Date().toISOString()};dbH.setApp(u);return u;}return a;});
    setApps(updated);
    toast_("Application forwarded to Settlers for processing.");
  };

  const complete=async(id)=>{
    const updated=apps.map(a=>{if(a.id===id){const u={...a,status:"completed",completedAt:new Date().toISOString()};dbH.setApp(u);return u;}return a;});
    setApps(updated);
    toast_("Application marked as Completed!");
  };

  // ── Admin send message to client ─────────────────────────────────────────
  const sendAdminMsg=async(appId,text,senderRole)=>{
    if(!text||!text.trim())return false;
    const msgText=text.trim();
    const updated=apps.map(a=>{
      if(a.id===appId){
        const msg={text:msgText,date:new Date().toISOString(),from:senderRole||"admin",read:false};
        const u={...a,messages:[...(a.messages||[]),msg]};
        dbH.setApp(u);
        // SMS notification to client
        const phone=(a.data?.telephone||"").toString().trim();
        if(phone) sendSMS(phone,`TaxReliefGH: New message on application ${appId}: "${msgText.substring(0,80)}". Login: https://taxreliefgh.web.app`);
        return u;
      }
      return a;
    });
    setApps(updated);
    toast_("✉️ Message sent to client!");
    return true;
  };

  const settlersUpd=async(id,status)=>{
    const fb=fbText[id]||"";
    const updated=apps.map(a=>{if(a.id===id){const u={...a,status,feedbacks:fb?[...a.feedbacks,{text:fb,date:new Date().toISOString()}]:a.feedbacks};dbH.setApp(u);return u;}return a;});
    setApps(updated);setFbText(p=>({...p,[id]:""}));toast_("Status updated.");
  };

  const saveVids=async(v)=>{setVids(v);await dbH.setVids(v);};
  const userApp=user?apps.find(a=>a.userId===user.id):null;

  if(!ready)return(<><style>{CSS}</style><div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#080f18"}}><span style={{color:"#F5C842",fontFamily:"Syne,sans-serif",fontSize:20,fontWeight:800,letterSpacing:".14em"}}>TAXRELIEFGH</span></div></>);

  return(
    <div id="trgh-root" style={{minHeight:"100vh",position:"relative",zoom:fontZoom}}>
      <style>{CSS}</style>
      {toast&&<div className={`toast t${toast.type}`}>{toast.msg}</div>}
      <Navbar user={user} logout={logout} setPage={setPage} userApp={userApp} dark={dark} onToggleDark={()=>setDark(d=>!d)} unreadMsgs={apps.reduce((s,a)=>s+((a.messages||[]).filter(m=>m.from==="client"&&!m.read).length),0)}/>
      {page==="home"&&<Home goAuth={goAuth} videos={videos}/>}
      {page==="auth"&&<Auth onLogin={login} onRegister={register} setPage={setPage}/>}
      {page==="form"&&user&&<TaxForm user={user} onSubmit={userApp?saveEditedApp:submitForm} setPage={setPage} existing={userApp} isEdit={!!userApp}/>}
      {page==="payment"&&user&&<Payment onPay={confirmPayment} user={user}/>}
      {page==="customer_dashboard"&&user&&<CustDash user={user} app={userApp} setPage={setPage} onRefresh={refreshApps} onDocsUpdate={refreshApps}/>}
      {page==="dev_dashboard"&&user?.role==="developer"&&<DevDash apps={apps} onApprove={approvePayment} onForward={forward} onComplete={complete} onSendMsg={sendAdminMsg} onDelete={deleteApp} onDevEdit={devSaveEdit} videos={videos} setVids={saveVids} setModal={setModal}/>}
      {page==="settlers_dashboard"&&user?.role==="settlers"&&<SetDash apps={apps.filter(a=>["forwarded_to_settlers","processing","completed"].includes(a.status))} onUpdate={settlersUpd} onSendMsg={sendAdminMsg} fbText={fbText} setFbText={setFbText} setModal={setModal}/>}
      {modal&&<AppModal app={modal} onClose={()=>setModal(null)} onSendMsg={sendAdminMsg}/>}
      <div style={{position:"fixed",bottom:24,right:24,zIndex:99999,display:"flex",flexDirection:"column",alignItems:"flex-end",gap:10}}>
        {/* Font size panel */}
        {showFontPanel&&(
          <div style={{
            background:"var(--card)",border:"1.5px solid var(--border)",borderRadius:16,
            padding:"16px 18px",boxShadow:"0 8px 32px rgba(0,0,0,.18)",minWidth:220,
            animation:"fadeIn .18s ease"
          }}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
              <span style={{fontSize:13,fontWeight:700,color:"var(--ink)",fontFamily:"Syne,sans-serif",textTransform:"uppercase",letterSpacing:".05em"}}>Text Size</span>
              <button onClick={()=>setShowFontPanel(false)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--muted)",fontSize:16,lineHeight:1}}>✕</button>
            </div>
            {/* Size preview */}
            <div style={{background:"var(--bg)",borderRadius:8,padding:"10px 12px",marginBottom:12,textAlign:"center",border:"1px solid var(--border)"}}>
              <span style={{fontSize:16,color:"var(--ink)",fontFamily:"Lora,serif"}}>Sample Text Aa</span>
            </div>
            {/* Preset buttons */}
            <div style={{display:"flex",gap:6,marginBottom:12}}>
              {[{label:"A",zoom:0.85,hint:"Small",fs:11},{label:"A",zoom:1,hint:"Normal",fs:14},{label:"A",zoom:1.15,hint:"Large",fs:17},{label:"A",zoom:1.3,hint:"X-Large",fs:20}].map(({label,zoom,hint,fs})=>(
                <button key={zoom} onClick={()=>{setFontZoom(zoom);try{localStorage.setItem("trgh_fontzoom",zoom);}catch(e){}document.getElementById("trgh-root")&&(document.getElementById("trgh-root").style.zoom=zoom);}}
                  title={hint}
                  style={{
                    flex:1,padding:"8px 4px",borderRadius:8,border:"2px solid",cursor:"pointer",
                    fontFamily:"Lora,serif",fontWeight:700,transition:"all .15s",
                    fontSize:fs,
                    borderColor:fontZoom===zoom?"var(--green)":"var(--border)",
                    background:fontZoom===zoom?"var(--green2)":"var(--bg)",
                    color:fontZoom===zoom?"var(--green)":"var(--ink2)"
                  }}>{label}</button>
              ))}
            </div>
            {/* Slider */}
            <input type="range" min="0.75" max="1.4" step="0.05" value={fontZoom}
              onChange={e=>{const v=parseFloat(e.target.value);setFontZoom(v);try{localStorage.setItem("trgh_fontzoom",v);}catch(e){}const r=document.getElementById("trgh-root");if(r)r.style.zoom=v;}}
              style={{width:"100%",accentColor:"var(--green)",cursor:"pointer"}}/>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:4}}>
              <span style={{fontSize:11,color:"var(--muted)"}}>Smaller</span>
              <span style={{fontSize:11,color:"var(--green)",fontWeight:700}}>{Math.round(fontZoom*100)}%</span>
              <span style={{fontSize:11,color:"var(--muted)"}}>Larger</span>
            </div>
            {fontZoom!==1&&(
              <button onClick={()=>{setFontZoom(1);try{localStorage.setItem("trgh_fontzoom",1);}catch(e){}const r=document.getElementById("trgh-root");if(r)r.style.zoom=1;}}
                style={{width:"100%",marginTop:10,padding:"6px",background:"none",border:"1px solid var(--border)",borderRadius:6,cursor:"pointer",fontSize:12,color:"var(--muted)",fontFamily:"Syne,sans-serif"}}>
                Reset to default (100%)
              </button>
            )}
          </div>
        )}
        {/* Font size button only */}
        <button onClick={()=>setShowFontPanel(p=>!p)}
          title="Adjust text size"
          style={{
            width:52,height:52,borderRadius:"50%",border:"none",cursor:"pointer",
            background:showFontPanel?"var(--green)":"var(--card)",
            boxShadow:"0 2px 16px rgba(0,0,0,.18)",
            fontSize:22,transition:"all .2s",
            color:showFontPanel?"#fff":"var(--ink)"
          }}>🔤</button>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// NAVBAR
// ═══════════════════════════════════════════════════════════════════════════
function Navbar({user,logout,setPage,userApp,dark,onToggleDark,unreadMsgs}){
  return(
    <nav className="nav">
      <div className="nbrand" onClick={()=>setPage("home")} style={{cursor:"pointer"}}>
        <div className="nlogo">TR<span style={{fontSize:8}}>GH</span></div>
        <div className="nbtext"><strong>TaxReliefGH</strong><span>taxreliefgh.web.app</span></div>
      </div>
      <div className="nlinks">
        {!user?(<>
          <button className="nb" onClick={()=>setPage("home")}>Home</button>
          <button className="nb nb-out" onClick={()=>setPage("auth")}>Sign In</button>
          <button className="nb nb-gold" onClick={()=>setPage("auth")}>Get Started →</button>
        </>):(<>
          <button className="nb" onClick={()=>setPage("home")}>Home</button>
          {user.role==="customer"&&(userApp
            ?<button className="nb" onClick={()=>setPage("customer_dashboard")}>My Dashboard</button>
            :<button className="nb nb-gold" onClick={()=>setPage("form")}>Apply Now</button>)}
          {user.role==="developer"&&<button className="nb nb-gold" onClick={()=>setPage("dev_dashboard")}>Admin</button>}
          {user.role==="settlers"&&<button className="nb nb-gold" onClick={()=>setPage("settlers_dashboard")}>Settlers</button>}
          <span className="upill">{user.name.split(" ")[0]}</span>
          <button className="nb nb-out" onClick={logout}>Sign Out</button>
        </>)}
        {(user?.role==="developer"||user?.role==="admin")&&unreadMsgs>0&&(
          <div style={{position:"relative",display:"flex",alignItems:"center"}}>
            <span style={{
              background:"#dc2626",color:"#fff",borderRadius:20,padding:"4px 10px",
              fontSize:12,fontFamily:"Syne,sans-serif",fontWeight:800,
              display:"flex",alignItems:"center",gap:5,
              boxShadow:"0 2px 8px rgba(220,38,38,.4)",
              animation:"pulse 1.5s infinite"
            }}>
              🔔 {unreadMsgs} new message{unreadMsgs>1?"s":""}
            </span>
          </div>
        )}
        <button onClick={onToggleDark} title={dark?"Switch to Light Mode":"Switch to Dark Mode"} style={{
          marginLeft:8,width:36,height:36,borderRadius:"50%",border:"1.5px solid var(--border)",
          background:"var(--card)",cursor:"pointer",fontSize:18,display:"flex",
          alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all .2s",
          boxShadow:"0 1px 4px rgba(0,0,0,.10)"
        }}>{dark?"☀️":"🌙"}</button>
      </div>
    </nav>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// HOME — ORDER: 1.Videos  2.Hero  3.Steps  4.Disclaimer  5.CTA  6.Footer
// ═══════════════════════════════════════════════════════════════════════════
function Home({goAuth,videos}){
  return(
    <div>

      {/* ── 1. VIDEOS SECTION ── */}
      <section style={{background:"#0f1923",padding:"72px 24px 60px"}}>
        <div style={{maxWidth:1080,margin:"0 auto"}}>
          <div style={{color:"rgba(255,255,255,.55)",fontSize:10,letterSpacing:".18em",textTransform:"uppercase",fontFamily:"Syne,sans-serif",fontWeight:700,marginBottom:8}}>Watch & Learn</div>
          <h2 style={{fontFamily:"Syne,sans-serif",fontSize:"clamp(26px,4vw,40px)",color:"#ffffff",marginBottom:8,lineHeight:1.2}}>Know Your <em style={{color:"#F5C842",fontStyle:"normal"}}>Tax Relief Rights</em></h2>
          <p style={{color:"rgba(255,255,255,.6)",fontSize:14,marginBottom:28,fontFamily:"Lora,serif",lineHeight:1.7}}>Watch these short guides to understand what you are entitled to as a government worker.</p>
          <div className="vgrid">
            {videos.map((v,i)=>(
              <VideoCard key={i} v={v}/>
            ))}
          </div>
        </div>
      </section>

      {/* ── 2. HERO SECTION ── */}
      <section style={{
        minHeight:"88vh",
        background:"linear-gradient(140deg,#0f1923 0%,#1a3050 55%,#0d2610 100%)",
        display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",
        textAlign:"center",padding:"80px 24px 60px",position:"relative",overflow:"hidden"
      }}>
        <div style={{position:"absolute",inset:0,background:"radial-gradient(ellipse 70% 50% at 50% 0%,rgba(201,153,26,.12),transparent)",pointerEvents:"none"}}/>
        <span className="hero-tag" style={{position:"relative",zIndex:5}}>🇬🇭 Tax Relief Made Simple — Powered by Settlers</span>
        <h1 style={{position:"relative",zIndex:5,fontSize:"clamp(36px,6vw,68px)",color:"#fff",lineHeight:1.08,maxWidth:800,margin:"20px 0 18px"}}>
          Reclaim Your<br/><em style={{color:"#F5C842",fontStyle:"normal"}}>Tax Relief Benefits</em><br/>Every Month
        </h1>
        <p style={{position:"relative",zIndex:5,fontSize:17,color:"rgba(255,255,255,.62)",maxWidth:500,lineHeight:1.75,marginBottom:44}}>
          The simplest way for Ghana government workers to apply for their annual tax relief — processed by Settlers, a licensed agent.
        </p>
        <div style={{position:"relative",zIndex:10,display:"flex",gap:14,flexWrap:"wrap",justifyContent:"center",marginBottom:48}}>
          <button onClick={goAuth} style={{
            background:"#C9991A",color:"#0f1923",padding:"16px 38px",borderRadius:8,
            fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:15,letterSpacing:".04em",
            border:"none",cursor:"pointer",boxShadow:"0 4px 18px rgba(201,153,26,.4)"
          }}>Get Started — Apply Now</button>
          <button onClick={goAuth} style={{
            background:"rgba(255,255,255,.1)",color:"#fff",padding:"16px 38px",borderRadius:8,
            fontFamily:"Syne,sans-serif",fontWeight:600,fontSize:15,letterSpacing:".04em",
            border:"1.5px solid rgba(255,255,255,.4)",cursor:"pointer"
          }}>Sign In to My Account</button>
        </div>
        <div style={{position:"relative",zIndex:5,display:"flex",flexWrap:"wrap",gap:8,justifyContent:"center"}}>
          {["🚓 Police","🎓 Teachers","🔥 Fire Service","🪖 Military","🏥 Health","⚖️ Judiciary","🏛️ Civil Service","🔒 Prisons","🛃 Customs"].map(s=>(
            <span key={s} style={{background:"rgba(255,255,255,.07)",border:"1px solid rgba(255,255,255,.12)",color:"rgba(255,255,255,.58)",padding:"5px 14px",borderRadius:100,fontSize:10,fontFamily:"Syne,sans-serif"}}>{s}</span>
          ))}
        </div>
      </section>

      {/* ── 3. STEPS SECTION ── */}
      <div style={{background:"#fff"}}>
        <div className="sec">
          <div className="slbl">Simple Process</div>
          <h2 className="stitle">Apply in <em style={{color:"var(--green)"}}>4 Easy Steps</em></h2>
          <div className="steps">
            {[
              {n:"1",i:"📝",t:"Create Account",d:"Register with your chosen username, password, name, region, town, occupation and sector."},
              {n:"2",i:"📋",t:"Fill the Form",d:"Complete the Tax Relief Application Form with your personal and employer details."},
              {n:"3",i:"💳",t:"Pay GH₵200",d:"Pay the one-time validation fee via MTN MoMo, Vodafone Cash or bank transfer."},
              {n:"4",i:"🎉",t:"Get Processed",d:"Settlers processes and submits your application. Track progress on your dashboard."},
            ].map(s=>(
              <div key={s.n} className="step">
                <div className="step-n">{s.n}</div>
                <div className="step-ico">{s.i}</div>
                <h3>{s.t}</h3><p>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── 4. DISCLAIMER ── */}
      <div style={{padding:"0 24px 72px",background:"var(--bg)"}}>
        <div className="disc">
          <h3>⚠️ Important Disclaimer — Please Read Before Applying</h3>
          <ul>
            <li><strong>Next Year Effect:</strong> All applications take effect in the <strong>following tax year</strong>. Applications submitted in 2025 reflect from January 2026 onwards.</li>
            <li><strong>Monthly Payslip:</strong> Once approved, your tax relief is <strong>applied automatically every month on your payslip</strong> — no further action needed.</li>
            <li><strong>Processing Fee:</strong> The GH₵200 fee is non-refundable once submitted.</li>
            <li><strong>Accuracy:</strong> All information must be accurate and truthful. False information is a criminal offence under Act 915.</li>
            <li><strong>One Application Per Year:</strong> Only one Tax Relief Card per employee per year is permitted.</li>
            <li><strong>Timeline:</strong> Processing takes 4–8 weeks after payment confirmation.</li>
          </ul>
        </div>
      </div>

      {/* ── 5. CTA BANNER ── */}
      <div style={{padding:"0 24px 72px",background:"var(--bg)"}}>
        <div style={{maxWidth:1080,margin:"0 auto",background:"linear-gradient(135deg,#0f1923,#1a3050)",borderRadius:16,padding:"52px 40px",textAlign:"center"}}>
          <h2 style={{color:"#fff",fontSize:32,marginBottom:10}}>Ready to Claim What Is Yours?</h2>
          <p style={{color:"rgba(255,255,255,.55)",fontSize:15,marginBottom:32}}>Thousands of government workers are already saving every month.</p>
          <div style={{display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap"}}>
            <button onClick={goAuth} style={{
              background:"#C9991A",color:"#0f1923",padding:"16px 38px",borderRadius:8,
              fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:15,letterSpacing:".04em",
              border:"none",cursor:"pointer",boxShadow:"0 4px 18px rgba(201,153,26,.4)"
            }}>Get Started — Apply Now</button>
            <button onClick={goAuth} style={{
              background:"rgba(255,255,255,.1)",color:"#fff",padding:"16px 38px",borderRadius:8,
              fontFamily:"Syne,sans-serif",fontWeight:600,fontSize:14,letterSpacing:".04em",
              border:"1.5px solid rgba(255,255,255,.4)",cursor:"pointer"
            }}>Sign In to My Account</button>
          </div>
        </div>
      </div>

      {/* ── 6. FOOTER ── */}
      <footer className="footer">
        <p>© 2025 <strong>TaxReliefGH</strong> · <strong>taxreliefgh.web.app</strong> · Processed by <strong>Settlers</strong> — Licensed Tax Relief Processing Agent</p>
        <p style={{marginTop:6,opacity:.5}}>support@settlers.gh · For government employees with employment income only · Not affiliated with any government body</p>
      </footer>

    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// AUTH — Sign In + Create Account with USERNAME field
// ═══════════════════════════════════════════════════════════════════════════
function Auth({onLogin,onRegister,setPage}){
  const [tab,setTab]=useState("login");
  const [loginUser,setLoginUser]=useState("");
  const [loginPass,setLoginPass]=useState("");
  const [reg,setReg]=useState({username:"",name:"",occupation:"",sector:"",region:"",town:"",email:"",phone:"",password:""});
  const sr=(k,v)=>setReg(p=>({...p,[k]:v}));

  return(
    <div className="aw">
      <div className="acard">
        <h2>TaxReliefGH</h2>
        <p className="sub">Claim your tax relief · taxreliefgh.web.app</p>
        <div className="tabs">
          <button className={`tab${tab==="login"?" on":""}`} onClick={()=>setTab("login")}>Sign In</button>
          <button className={`tab${tab==="register"?" on":""}`} onClick={()=>setTab("register")}>Create Account</button>
        </div>

        {tab==="login"&&(
          <div>
            <div className="fg">
              <label className="fl">Username</label>
              <input className="fi" type="text" placeholder="Enter your username" value={loginUser} onChange={e=>setLoginUser(e.target.value.trim())}/>
            </div>
            <div className="fg">
              <label className="fl">Password</label>
              <input className="fi" type="password" placeholder="••••••••" value={loginPass} onChange={e=>setLoginPass(e.target.value)}/>
            </div>
            <button className="bauth gold" onClick={()=>onLogin(loginUser.trim(),loginPass)}>Sign In to My Account</button>
          </div>
        )}

        {tab==="register"&&(
          <div>
            {/* ── LOGIN CREDENTIALS BOX ── */}
            <div style={{background:"linear-gradient(135deg,#fffbf0,#fff8e1)",border:"2px solid #C9991A",borderRadius:10,padding:"18px 16px",marginBottom:18}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
                <span style={{fontSize:22}}>🔑</span>
                <div>
                  <p style={{fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:13,color:"#0f1923",margin:0}}>Choose Your Login Details</p>
                  <p style={{fontSize:11,color:"#6b7a8d",margin:"2px 0 0"}}>You will use these every time you sign in</p>
                </div>
              </div>
              <div className="fg" style={{marginBottom:10}}>
                <label className="fl">Username <span className="req">*</span></label>
                <input className="fi" type="text"
                  placeholder="e.g. kwame2025  (no spaces, no capitals)"
                  value={reg.username}
                  onChange={e=>sr("username",e.target.value.replace(/\s/g,""))}
                  style={{borderColor:reg.username.length>=3?"#006B3F":"#dde3ea"}}/>
                {reg.username.length>=3
                  ?<small style={{color:"#006B3F",fontSize:11,marginTop:3,display:"block",fontWeight:700}}>✅ Username: <strong>{reg.username}</strong> — write this down to sign in!</small>
                  :<small style={{color:"#6b7a8d",fontSize:11,marginTop:3,display:"block"}}>⚠️ No spaces allowed. Write it down — you need it to sign in.</small>}
              </div>
              <div className="fg" style={{marginBottom:0}}>
                <label className="fl">Password <span className="req">*</span></label>
                <input className="fi" type="password" placeholder="Min 6 characters" value={reg.password} onChange={e=>sr("password",e.target.value)}/>
              </div>
            </div>

            {/* ── PERSONAL DETAILS ── */}
            <div className="fg">
              <label className="fl">Full Name <span className="req">*</span></label>
              <input className="fi" placeholder="e.g. Kwame Asante Mensah" value={reg.name} onChange={e=>sr("name",e.target.value)}/>
            </div>
            <div className="fg">
              <label className="fl">Job Title / Occupation <span className="req">*</span></label>
              <input className="fi" placeholder="e.g. Police Officer, Teacher, Nurse" value={reg.occupation} onChange={e=>sr("occupation",e.target.value)}/>
            </div>
            <div className="fg">
              <label className="fl">Government Sector <span className="req">*</span></label>
              <select className="fi" value={reg.sector} onChange={e=>sr("sector",e.target.value)}>
                <option value="">Select your sector</option>
                {SECTORS.map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="tcol2">
              <div className="fg">
                <label className="fl">Region <span className="req">*</span></label>
                <select className="fi" value={reg.region} onChange={e=>{sr("region",e.target.value);sr("town","");}}>
                  <option value="">Select region</option>
                  {GH_REGIONS.map(r=><option key={r}>{r}</option>)}
                </select>
              </div>
              <div className="fg">
                <label className="fl">Town / City <span className="req">*</span></label>
                <select className="fi" value={reg.town} onChange={e=>sr("town",e.target.value)} disabled={!reg.region}>
                  <option value="">{reg.region?"Select your town":"Select region first"}</option>
                  {(GH_TOWNS[reg.region]||[]).map(t=><option key={t}>{t}</option>)}
                </select>
              </div>
            </div>
            <div className="fg">
              <label className="fl">Email Address</label>
              <input className="fi" type="email" placeholder="your@email.com" value={reg.email} onChange={e=>sr("email",e.target.value)}/>
            </div>
            <div className="fg">
              <label className="fl">Phone Number <span className="req">*</span></label>
              <input className="fi" type="tel" placeholder="0244 000 000" value={reg.phone} onChange={e=>sr("phone",e.target.value)}/>
            </div>

            <button className="bauth gold" onClick={()=>{
              if(!reg.username||reg.username.length<3){alert("Please choose a username (at least 3 characters).");return;}
              if(!reg.password||reg.password.length<6){alert("Password must be at least 6 characters.");return;}
              if(!reg.name||!reg.sector||!reg.region||!reg.town||!reg.phone||!reg.occupation){alert("Please fill all required fields.");return;}
              onRegister(reg);
            }}>Create Account & Start Application</button>
          </div>
        )}

        <div className="aswitch">
          <button onClick={()=>setPage("home")}>← Back to Home</button>

        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// TAX FORM — with multiple attachments
// ═══════════════════════════════════════════════════════════════════════════
function TaxForm({user,onSubmit,setPage,existing,isEdit}){
  const [uploading,setUploading]=useState(false);
  const [uploadMsg,setUploadMsg]=useState("");
  const existingData=existing?.data||{};
  const [f,setF]=useState(isEdit&&existing?{
    surname:existingData.surname||"",otherNames:existingData.otherNames||"",
    gender:existingData.gender||"",dob:existingData.dob||"",
    motherMaidenName:existingData.motherMaidenName||"",
    socialSecNo:existingData.socialSecNo||"",taxFileNo:existingData.taxFileNo||"",
    employerName:existingData.employerName||user.sector||"",
    employerAddress:existingData.employerAddress||"",
    telephone:existingData.telephone||user.phone||"",
    ghanaCardNo:existingData.ghanaCardNo||"",sector:existingData.sector||user.sector||"",
    maritalStatus:existingData.maritalStatus||"",spouseName:existingData.spouseName||"",
    spouseDob:existingData.spouseDob||"",spouseGhanaCard:existingData.spouseGhanaCard||"",spouseSsnit:existingData.spouseSsnit||"",
    numChildren:existingData.numChildren||"0",
    children:existingData.children||[{name:"",dob:"",school:""},{name:"",dob:"",school:""},{name:"",dob:"",school:""}],
    disabled:existingData.disabled||"no",
    attachedFiles:existingData.attachedFiles||[],
    employerDecl:existingData.employerDecl||false,employeeDecl:existingData.employeeDecl||false
  }:{
    surname:"",otherNames:"",gender:"",dob:"",motherMaidenName:"",
    socialSecNo:"",taxFileNo:"",employerName:user.sector||"",employerAddress:"",
    telephone:user.phone||"",ghanaCardNo:"",sector:user.sector||"",
    maritalStatus:"",spouseName:"",spouseDob:"",spouseGhanaCard:"",spouseSsnit:"",
    numChildren:"0",children:[{name:"",dob:"",school:""},{name:"",dob:"",school:""},{name:"",dob:"",school:""}],
    disabled:"no",attachedFiles:[],employerDecl:false,employeeDecl:false
  });



  const sf=(k,v)=>setF(p=>({...p,[k]:v}));
  const sc=(i,k,v)=>{const c=[...f.children];c[i]={...c[i],[k]:v};setF(p=>({...p,children:c}));};

  // ── Google Drive upload via Apps Script proxy ───────────────────────────
  // GDRIVE_URL is set by the admin in Dev Dashboard settings
  const GDRIVE_URL = window.__GDRIVE_SCRIPT_URL__ || "";

  const compressImage=async(file)=>{
    return new Promise(resolve=>{
      const img=new Image();
      const url=URL.createObjectURL(file);
      img.onload=()=>{
        URL.revokeObjectURL(url);
        const MAX=1024;
        let w=img.width,h=img.height;
        if(w>MAX){h=Math.round(h*MAX/w);w=MAX;}
        const canvas=document.createElement("canvas");
        canvas.width=w;canvas.height=h;
        canvas.getContext("2d").drawImage(img,0,0,w,h);
        resolve(canvas.toDataURL("image/jpeg",0.80));
      };
      img.onerror=()=>{URL.revokeObjectURL(url);resolve(null);};
      img.src=url;
    });
  };

  const addFiles=async(e)=>{
    const files=Array.from(e.target.files);
    if(!files.length)return;
    setUploading(true);
    const newEntries=[];
    const scriptUrl=window.__GDRIVE_SCRIPT_URL__||"";

    for(let i=0;i<files.length;i++){
      const file=files[i];
      setUploadMsg(`Processing ${i+1}/${files.length}: ${file.name}...`);
      try{
        const isImage=/^image\//i.test(file.type);

        // ── STEP 1: read and compress ──────────────────────────────────────
        let b64="";
        if(isImage){
          // Compress to max 800px, 65% quality → typically 60-180KB
          b64=await new Promise(res=>{
            const img=new Image();
            const url=URL.createObjectURL(file);
            img.onload=()=>{
              URL.revokeObjectURL(url);
              const MAX=800;
              let w=img.width,h=img.height;
              if(w>MAX){h=Math.round(h*MAX/w);w=MAX;}
              if(h>MAX){w=Math.round(w*MAX/h);h=MAX;}
              const c=document.createElement("canvas");
              c.width=w;c.height=h;
              c.getContext("2d").drawImage(img,0,0,w,h);
              res(c.toDataURL("image/jpeg",0.65));
            };
            img.onerror=()=>{URL.revokeObjectURL(url);res("");};
            img.src=url;
          });
          if(!b64){setUploadMsg(`❌ Could not read ${file.name}`);continue;}
        } else {
          // PDF / doc — reject if over 4MB (won't fit in RTDB)
          if(file.size>4*1024*1024){
            setUploadMsg(`⚠️ ${file.name} is too large (${(file.size/1024/1024).toFixed(1)}MB). Max 4MB for PDFs.`);
            await new Promise(r=>setTimeout(r,3000));
            continue;
          }
          b64=await new Promise((res,rej)=>{const rd=new FileReader();rd.onload=ev=>res(ev.target.result);rd.onerror=rej;rd.readAsDataURL(file);});
        }

        const kb=Math.round(b64.length*0.75/1024);

        // ── STEP 2: try Google Drive if script URL is set ──────────────────
        if(scriptUrl&&scriptUrl.includes("script.google.com")){
          setUploadMsg(`☁️ Uploading to Drive: ${file.name}...`);
          try{
            const resp=await fetch(scriptUrl,{method:"POST",body:JSON.stringify({name:file.name,type:file.type||"application/octet-stream",data:b64})});
            const txt=await resp.text();
            const result=JSON.parse(txt);
            if(result.success&&result.url){
              newEntries.push({name:file.name,type:file.type,driveUrl:result.url,viewUrl:result.viewUrl||result.url,driveId:result.id||""});
              setUploadMsg(`☁️ ${file.name} saved to Google Drive ✓`);
              continue;
            }
          }catch(de){console.warn("Drive upload failed, using Firebase:",de.message);}
        }

        // ── STEP 3: store in Firebase (already compressed) ────────────────
        newEntries.push({name:file.name,type:file.type,data:b64});
        setUploadMsg(`✅ ${file.name} ready (${kb}KB${isImage?" compressed":""})`);
      }catch(err){
        setUploadMsg(`❌ Error reading ${file.name}: ${err.message||err}`);
        await new Promise(r=>setTimeout(r,2000));
      }
    }

    if(newEntries.length){
      const existingNames=f.attachedFiles.map(x=>x.name||x);
      const merged=[...f.attachedFiles,...newEntries.filter(n=>!existingNames.includes(n.name))];
      sf("attachedFiles",merged);
    }
    setUploading(false);
    const dCt=newEntries.filter(x=>x.driveUrl).length;
    const fCt=newEntries.filter(x=>x.data).length;
    setUploadMsg(dCt?`☁️ ${dCt} on Drive${fCt?`, ${fCt} in Firebase`:""} — ready to submit`:fCt?`✅ ${fCt} file(s) ready — submit your form`:"");
    setTimeout(()=>setUploadMsg(""),6000);
    e.target.value="";
  };

  const removeFile=(i)=>sf("attachedFiles",f.attachedFiles.filter((_,j)=>j!==i));

  // When editing — load real file data from Firebase so files show as downloadable
  useEffect(()=>{
    if(!isEdit||!existing)return;
    (async()=>{
      const fetched=await dbH.getFiles(existing.id);
      if(fetched&&fetched.length>0){
        sf("attachedFiles",fetched);
      }
    })();
  },[isEdit,existing?.id]);

  if(existing&&!isEdit)return(
    <div className="fpage" style={{textAlign:"center",paddingTop:80}}>
      <div style={{fontSize:54,marginBottom:14}}>📋</div>
      <h2 style={{color:"var(--ink)",marginBottom:8}}>Application Already Submitted</h2>
      <p style={{color:"var(--muted)",marginBottom:22,fontSize:14}}>Track its progress in your dashboard.</p>
      <button className="bsub" onClick={()=>setPage("customer_dashboard")}>View My Dashboard →</button>
    </div>
  );
  return(
    <div className="fpage">
      <div className="fhd">
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{background:"var(--gold)",color:"#0f1923",borderRadius:7,padding:"7px 12px",fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:11}}>TRGH</div>
          <div><h2>Tax Relief Application Form</h2><p>For employees with employment income only · taxreliefgh.web.app</p></div>
        </div>
      </div>
      <div className="fbody">

        <div className="fsec">Personal Particulars</div>
        <div className="f2">
          <div className="fg"><label className="fl">Surname <span className="req">*</span></label><input className="fi" placeholder="Last name" value={f.surname} onChange={e=>sf("surname",e.target.value)}/></div>
          <div className="fg"><label className="fl">Other Names <span className="req">*</span></label><input className="fi" placeholder="First & middle names" value={f.otherNames} onChange={e=>sf("otherNames",e.target.value)}/></div>
          <div className="fg">
            <label className="fl">Gender <span className="req">*</span></label>
            <div className="rgrp">
              <label className="rl"><input type="radio" name="gnd" checked={f.gender==="M"} onChange={()=>sf("gender","M")}/> Male</label>
              <label className="rl"><input type="radio" name="gnd" checked={f.gender==="F"} onChange={()=>sf("gender","F")}/> Female</label>
            </div>
          </div>
          <div className="fg"><label className="fl">Date of Birth <span className="req">*</span></label><input className="fi" type="date" value={f.dob} onChange={e=>sf("dob",e.target.value)}/></div>
          <div className="fg s2"><label className="fl">Mother Maiden Name</label><input className="fi" value={f.motherMaidenName} onChange={e=>sf("motherMaidenName",e.target.value)}/></div>
          <div className="fg"><label className="fl">SSNIT No.</label><input className="fi" placeholder="Social Security number" value={f.socialSecNo} onChange={e=>sf("socialSecNo",e.target.value)}/></div>
          <div className="fg"><label className="fl">Tax File No. (TIN)</label><input className="fi" placeholder="TIN" value={f.taxFileNo} onChange={e=>sf("taxFileNo",e.target.value)}/></div>
          <div className="fg"><label className="fl">Ghana Card No. <span className="req">*</span></label><input className="fi" placeholder="GHA-XXXXXXXXX-X" value={f.ghanaCardNo} onChange={e=>sf("ghanaCardNo",e.target.value)}/></div>
          <div className="fg"><label className="fl">Telephone No.</label><input className="fi" placeholder="0244 000 000" value={f.telephone} onChange={e=>sf("telephone",e.target.value)}/></div>
        </div>

        <div className="fsec">Employer Details</div>
        <div className="f2">
          <div className="fg"><label className="fl">Government Sector</label>
            <select className="fi" value={f.sector} onChange={e=>sf("sector",e.target.value)}>
              {SECTORS.map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
          <div className="fg"><label className="fl">Employer / Department</label><input className="fi" value={f.employerName} onChange={e=>sf("employerName",e.target.value)}/></div>
          <div className="fg s2"><label className="fl">Employer Address</label><input className="fi" value={f.employerAddress} onChange={e=>sf("employerAddress",e.target.value)}/></div>
        </div>

        <div className="fsec">Marital Status</div>
        <div className="fg">
          <div className="rgrp">
            <label className="rl"><input type="radio" name="ms" checked={f.maritalStatus==="Married"} onChange={()=>sf("maritalStatus","Married")}/> Married</label>
            <label className="rl"><input type="radio" name="ms" checked={f.maritalStatus==="Single"} onChange={()=>sf("maritalStatus","Single")}/> Single</label>
          </div>
        </div>
        {f.maritalStatus==="Married"&&(
          <div className="f2">
            <div className="fg s2"><label className="fl">Spouse Name</label><input className="fi" value={f.spouseName} onChange={e=>sf("spouseName",e.target.value)}/></div>
            <div className="fg"><label className="fl">Spouse Date of Birth</label><input className="fi" type="date" value={f.spouseDob} onChange={e=>sf("spouseDob",e.target.value)}/></div>
            <div className="fg"><label className="fl">Spouse Ghana Card No.</label><input className="fi" placeholder="GHA-XXXXXXXXX-X" value={f.spouseGhanaCard} onChange={e=>sf("spouseGhanaCard",e.target.value)}/></div>
            <div className="fg"><label className="fl">Spouse SSNIT Number <span style={{color:"var(--muted)",fontWeight:400,fontSize:11}}>(if available)</span></label><input className="fi" placeholder="e.g. C000123456" value={f.spouseSsnit} onChange={e=>sf("spouseSsnit",e.target.value)}/></div>
          </div>
        )}

        <div className="fsec">Children Education Relief</div>
        <p style={{fontSize:13,color:"var(--muted)",marginBottom:12}}>Maximum 3 children. Only one parent can claim per child.</p>
        <div className="fg"><label className="fl">Number of Children</label>
          <select className="fi" style={{width:130}} value={f.numChildren} onChange={e=>sf("numChildren",e.target.value)}>
            {["0","1","2","3"].map(n=><option key={n}>{n}</option>)}
          </select>
        </div>
        {parseInt(f.numChildren)>0&&(
          <table className="ctbl">
            <thead><tr><th>Name</th><th>Date of Birth</th><th>Educational Institution</th></tr></thead>
            <tbody>{Array.from({length:parseInt(f.numChildren)}).map((_,i)=>(
              <tr key={i}>
                <td><input placeholder={`Child ${i+1} name`} value={f.children[i]?.name||""} onChange={e=>sc(i,"name",e.target.value)}/></td>
                <td><input type="date" value={f.children[i]?.dob||""} onChange={e=>sc(i,"dob",e.target.value)}/></td>
                <td><input placeholder="School name" value={f.children[i]?.school||""} onChange={e=>sc(i,"school",e.target.value)}/></td>
              </tr>
            ))}</tbody>
          </table>
        )}

        <div className="fsec">Disability</div>
        <div className="fg">
          <div className="rgrp">
            <label className="rl"><input type="radio" name="dis" checked={f.disabled==="yes"} onChange={()=>sf("disabled","yes")}/> Yes</label>
            <label className="rl"><input type="radio" name="dis" checked={f.disabled==="no"} onChange={()=>sf("disabled","no")}/> No</label>
          </div>
        </div>

        <div className="fsec">Attach Supporting Documents</div>
        <p style={{fontSize:12.5,color:"var(--muted)",marginBottom:12}}>Attach multiple documents — SSNIT card, Ghana Card, disability certificate, appointment letter, etc.</p>
        <input id="fup" type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" multiple style={{display:"none"}} onChange={addFiles} disabled={uploading}/>
        {uploadMsg&&(
          <div style={{background:uploadMsg.startsWith("✅")?"#e6f4ed":"#fff8e6",border:`1.5px solid ${uploadMsg.startsWith("✅")?"#006B3F":"#C9991A"}`,borderRadius:8,padding:"10px 14px",marginBottom:10,fontSize:13,color:uploadMsg.startsWith("✅")?"#006B3F":"#92400e",fontFamily:"Syne,sans-serif",fontWeight:600,display:"flex",alignItems:"center",gap:8}}>
            {uploadMsg.startsWith("✅")?"✅":"⏳"} {uploadMsg}
          </div>
        )}
        <div className="upbox" onClick={()=>!uploading&&document.getElementById("fup").click()} style={{opacity:uploading?0.6:1,cursor:uploading?"not-allowed":"pointer"}}>
          <div style={{fontSize:32,marginBottom:8}}>{uploading?"⏳":"📎"}</div>
          <p style={{fontWeight:700,color:"var(--ink2)",fontFamily:"Syne,sans-serif",fontSize:13}}>{uploading?"Uploading files, please wait...":"Click to attach documents"}</p>
          <p>PDF, JPG, PNG, DOC accepted · Select multiple files at once</p>
        </div>
        {f.attachedFiles.length>0&&(
          <div style={{marginTop:12}}>
            <p style={{fontSize:11,fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:6}}>
              {f.attachedFiles.length} document{f.attachedFiles.length>1?"s":""} attached
            </p>
            {f.attachedFiles.map((file,i)=>{
              const fname=typeof file==="string"?file:(file.name||`File ${i+1}`);
              const onDrive=file&&file.driveUrl;
              const inFirebase=file&&file.data;
              const icon=onDrive?"☁️":fname.toLowerCase().match(/\.(jpg|jpeg|png|gif|webp)$/)?"🖼️":"📄";
              return(
              <div key={i} style={{display:"flex",alignItems:"center",justifyContent:"space-between",background:onDrive?"#e6f4ed":inFirebase?"#f0f4ff":"#fafafa",border:`1.5px solid ${onDrive?"#b3dfc5":inFirebase?"#c0ccf0":"#ddd"}`,borderRadius:8,padding:"9px 12px",marginBottom:6,gap:8}}>
                <div style={{display:"flex",alignItems:"center",gap:8,flex:1,minWidth:0}}>
                  <span style={{fontSize:16,flexShrink:0}}>{icon}</span>
                  <div style={{minWidth:0}}>
                    <p style={{fontSize:13,fontWeight:700,color:"var(--ink)",margin:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{fname}</p>
                    <p style={{fontSize:10,color:onDrive?"#006B3F":inFirebase?"#3b5bdb":"#888",margin:0,fontWeight:600}}>{onDrive?"☁️ Google Drive":inFirebase?"✅ Ready":"📋 Saved"}</p>
                  </div>
                </div>
                <button onClick={()=>removeFile(i)} style={{background:"#fee2e2",border:"none",color:"#dc2626",cursor:"pointer",fontSize:12,borderRadius:6,padding:"4px 10px",flexShrink:0,fontWeight:700}}>✕</button>
              </div>
              );
            })}
            <button onClick={()=>document.getElementById("fup").click()} style={{
              display:"flex",alignItems:"center",gap:6,marginTop:6,padding:"7px 16px",
              background:"none",border:"1.5px dashed #dde3ea",borderRadius:6,
              fontSize:12,color:"var(--ink2)",cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:600
            }}>＋ Add more documents</button>
          </div>
        )}

        <div className="fsec">Declarations</div>
        <div className="declbox">
          <strong style={{color:"var(--ink)",display:"block",marginBottom:6,fontFamily:"Syne,sans-serif",fontSize:12,textTransform:"uppercase",letterSpacing:".05em"}}>Employer Declaration</strong>
          I hereby declare that the above information is to the best of my knowledge true, correct and complete.
        </div>
        <div className="fg" style={{marginTop:10}}>
          <label className="ckl"><input type="checkbox" checked={f.employerDecl} onChange={e=>sf("employerDecl",e.target.checked)}/> I confirm the employer declaration above</label>
        </div>
        <div className="declbox" style={{marginTop:12}}>
          <strong style={{color:"var(--ink)",display:"block",marginBottom:6,fontFamily:"Syne,sans-serif",fontSize:12,textTransform:"uppercase",letterSpacing:".05em"}}>Employee Declaration</strong>
          I certify the information is correct. This is my primary employment and no other Tax Relief Card is issued for this year.
        </div>
        <div className="fg" style={{marginTop:10}}>
          <label className="ckl"><input type="checkbox" checked={f.employeeDecl} onChange={e=>sf("employeeDecl",e.target.checked)}/> I confirm the employee declaration and certify all information is truthful</label>
        </div>

        <div className="fact">
          <button className="bcan" onClick={()=>setPage("home")}>Cancel</button>
          <button className="bsub" onClick={()=>{
            if(!f.surname||!f.otherNames||!f.gender||!f.dob||!f.ghanaCardNo){alert("Please fill all required personal details.");return;}
            if(!f.employerDecl||!f.employeeDecl){alert("Please confirm both declarations.");return;}
            onSubmit(f);
          }}>{isEdit?"💾 Save Changes →":"Submit Application →"}</button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// PAYMENT
// ═══════════════════════════════════════════════════════════════════════════
function Payment({onPay,user}){
  const HUBTEL_API_ID   = "wppnllg";
  const HUBTEL_API_KEY  = "d229e5e5de5149ceb19bf707af075951";
  const HUBTEL_MERCHANT = "2022622";
  const RETURN_URL      = "https://taxreliefgh.web.app";

  const [loading,setLoading]   = useState(false);
  const [error,setError]       = useState("");
  const [showManual,setManual] = useState(false);
  // Manual fallback state
  const [method,setMethod]     = useState("");
  const [txnId,setTxnId]       = useState("");
  const [confirmed,setConf]    = useState(false);
  const payRef = "TRGH-"+(user?.username||user?.name?.split(" ")[0]||"Customer")+"-"+Date.now();

  const initiateHubtel = async()=>{
    setLoading(true); setError("");
    try{
      const auth = btoa(HUBTEL_API_ID+":"+HUBTEL_API_KEY);
      const body = JSON.stringify({
        merchantAccountNumber: HUBTEL_MERCHANT,
        description:           "TaxReliefGH - Validation Fee",
        amount:                200,
        cancellationUrl:       RETURN_URL+"?hubtel=cancelled",
        returnUrl:             RETURN_URL+"?hubtel=success",
        clientReference:       payRef
      });
      const res = await fetch("https://payproxyapi.hubtel.com/items/initiate",{
        method:"POST",
        headers:{"Content-Type":"application/json","Authorization":"Basic "+auth},
        body
      });
      if(!res.ok) throw new Error("HTTP "+res.status);
      const data = await res.json();
      const url  = data?.data?.checkoutUrl || data?.checkoutUrl;
      if(!url) throw new Error("No checkout URL returned");
      window.location.href = url;
    }catch(e){
      console.error("Hubtel error:",e);
      setError("Could not connect to Hubtel payment. Please use manual payment below.");
      setManual(true);
    }finally{
      setLoading(false);
    }
  };

  const METHODS=[
    {id:"momo",  ico:"📱",label:"MTN Mobile Money",   name:"AMIN MLM TRADING ENT.",number:"0597643120"},
    {id:"voda",  ico:"📲",label:"Vodafone Cash",       name:"AMIN MORO MOHAMMED",   number:"0505027255"},
    {id:"airtel",ico:"📶",label:"AirtelTigo Money",    name:"AMIN MORO MOHAMMED",   number:""},
    {id:"bank",  ico:"🏦",label:"Bank Transfer — GCB", name:"AMIN MORO MOHAMMED",   number:"3021010117318"},
  ];
  const selected  = METHODS.find(m=>m.id===method);
  const canSubmit = confirmed&&method&&txnId.trim().length>=4;

  const ROW=({label,value,highlight})=>(
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 0",borderBottom:"1px solid rgba(255,255,255,.1)"}}>
      <span style={{fontSize:13,color:"rgba(255,255,255,.65)",fontFamily:"Syne,sans-serif"}}>{label}</span>
      <span style={{fontSize:14,fontWeight:700,color:highlight?"#F5C842":"#ffffff",fontFamily:"Syne,sans-serif"}}>{value}</span>
    </div>
  );

  return(
    <div className="pw">
      <div className="pcard" style={{background:"#0f1923",border:"1px solid rgba(255,255,255,.12)"}}>
        <div style={{fontSize:44,marginBottom:10}}>💳</div>
        <h2 style={{color:"#ffffff",fontSize:24,fontFamily:"Syne,sans-serif",fontWeight:800,marginBottom:6}}>Validation Fee</h2>
        <p style={{color:"rgba(255,255,255,.7)",fontSize:14,marginBottom:20,lineHeight:1.7}}>Complete your one-time processing fee to submit your application.</p>

        {/* Amount */}
        <div style={{background:"rgba(201,153,26,.15)",border:"1.5px solid rgba(201,153,26,.4)",borderRadius:10,padding:"14px 20px",marginBottom:20,textAlign:"center"}}>
          <p style={{color:"rgba(255,255,255,.6)",fontSize:11,fontFamily:"Syne,sans-serif",letterSpacing:".1em",textTransform:"uppercase",marginBottom:4}}>Amount to Pay</p>
          <p style={{color:"#F5C842",fontSize:36,fontFamily:"Syne,sans-serif",fontWeight:800}}>GH₵ 200</p>
        </div>

        {!showManual&&(
          <div style={{marginBottom:16}}>
            <div style={{background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.12)",borderRadius:10,padding:"18px",marginBottom:12,textAlign:"center"}}>
              <p style={{color:"rgba(255,255,255,.7)",fontSize:13,marginBottom:12,lineHeight:1.6}}>
                Pay securely with <strong style={{color:"#F5C842"}}>MTN MoMo, Vodafone Cash, AirtelTigo</strong> or <strong style={{color:"#F5C842"}}>Credit/Debit Card</strong>
              </p>
              <div style={{display:"flex",justifyContent:"center",gap:14,marginBottom:16,fontSize:26}}>
                <span title="MTN MoMo">📱</span>
                <span title="Vodafone Cash">📲</span>
                <span title="AirtelTigo">📶</span>
                <span title="Card">💳</span>
              </div>
              <button onClick={initiateHubtel} disabled={loading} style={{
                width:"100%",padding:"16px",borderRadius:10,fontSize:16,
                fontFamily:"Syne,sans-serif",fontWeight:800,letterSpacing:".06em",
                textTransform:"uppercase",border:"none",
                cursor:loading?"not-allowed":"pointer",
                background:loading?"rgba(255,255,255,.1)":"linear-gradient(135deg,#006B3F,#00a85a)",
                color:"#ffffff",transition:"all .2s",
                boxShadow:loading?"none":"0 4px 20px rgba(0,107,63,.5)"
              }}>
                {loading?"🔄 Connecting to Hubtel...":"🔒 Pay GH₵200 via Hubtel →"}
              </button>
              {loading&&<p style={{color:"rgba(255,255,255,.5)",fontSize:12,marginTop:8}}>Opening secure Hubtel payment page...</p>}
              <p style={{color:"rgba(255,255,255,.4)",fontSize:11,marginTop:10}}>You will receive an SMS confirmation after successful payment</p>
            </div>

            {error&&(
              <div style={{background:"rgba(220,38,38,.15)",border:"1px solid rgba(220,38,38,.4)",borderRadius:8,padding:"12px 14px",marginBottom:10}}>
                <p style={{color:"#fca5a5",fontSize:13,margin:0}}>⚠️ {error}</p>
              </div>
            )}

            <button onClick={()=>setManual(true)} style={{
              width:"100%",padding:"11px",background:"rgba(255,255,255,.06)",
              border:"1px solid rgba(255,255,255,.15)",borderRadius:8,
              color:"rgba(255,255,255,.55)",fontSize:12,fontFamily:"Syne,sans-serif",cursor:"pointer"
            }}>
              Having trouble? Pay manually instead →
            </button>
          </div>
        )}

        {showManual&&(
          <div>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
              <p style={{color:"rgba(255,255,255,.8)",fontSize:13,fontFamily:"Syne,sans-serif",fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",margin:0}}>Manual Payment</p>
              <button onClick={()=>{setManual(false);setError("");}} style={{background:"none",border:"none",color:"#F5C842",cursor:"pointer",fontSize:12,fontFamily:"Syne,sans-serif",fontWeight:600}}>← Use Hubtel instead</button>
            </div>

            <div style={{background:"rgba(255,255,255,.06)",border:"1px solid rgba(255,255,255,.15)",borderRadius:10,padding:"14px 18px",marginBottom:16}}>
              <p style={{color:"rgba(255,255,255,.55)",fontSize:11,fontFamily:"Syne,sans-serif",letterSpacing:".1em",textTransform:"uppercase",marginBottom:6}}>Your Payment Reference</p>
              <p style={{color:"#F5C842",fontSize:24,fontFamily:"Syne,sans-serif",fontWeight:800,marginBottom:4}}>{user?.username||"Customer"}</p>
              <p style={{color:"rgba(255,255,255,.65)",fontSize:12.5,lineHeight:1.7}}>⚠️ Use <strong style={{color:"#F5C842"}}>{user?.username||"Customer"}</strong> as your <strong style={{color:"#fff"}}>reference</strong> when paying.</p>
            </div>

            <p style={{color:"rgba(255,255,255,.8)",fontSize:13,fontFamily:"Syne,sans-serif",fontWeight:700,marginBottom:10,textTransform:"uppercase",letterSpacing:".06em"}}>Select Payment Method</p>
            <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
              {METHODS.map(m=>(
                <button key={m.id} onClick={()=>setMethod(m.id)} style={{
                  display:"flex",alignItems:"center",gap:14,padding:"14px 16px",
                  background:method===m.id?"rgba(201,153,26,.2)":"rgba(255,255,255,.05)",
                  border:method===m.id?"2px solid #C9991A":"2px solid rgba(255,255,255,.12)",
                  borderRadius:10,cursor:"pointer",textAlign:"left",width:"100%",transition:"all .2s"
                }}>
                  <span style={{fontSize:26,flexShrink:0}}>{m.ico}</span>
                  <div>
                    <p style={{color:"#ffffff",fontWeight:700,fontSize:14,fontFamily:"Syne,sans-serif",margin:0}}>{m.label}</p>
                    {m.number&&<p style={{color:"rgba(255,255,255,.6)",fontSize:12.5,margin:"3px 0 0"}}>{m.name} · <strong style={{color:"#F5C842"}}>{m.number}</strong></p>}
                  </div>
                  {method===m.id&&<span style={{marginLeft:"auto",color:"#F5C842",fontSize:20}}>✓</span>}
                </button>
              ))}
            </div>

            {selected&&(
              <div style={{background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.15)",borderRadius:10,padding:"16px 18px",marginBottom:16}}>
                <p style={{color:"rgba(255,255,255,.55)",fontSize:11,fontFamily:"Syne,sans-serif",letterSpacing:".1em",textTransform:"uppercase",marginBottom:10}}>Payment Instructions</p>
                {selected.number&&<ROW label="Send to Number" value={selected.number} highlight/>}
                <ROW label="Account Name" value={selected.name}/>
                <ROW label="Amount" value="GH₵ 200" highlight/>
                <ROW label="Reference" value={user?.username||"Customer"} highlight/>
              </div>
            )}

            {method&&(
              <div style={{marginBottom:16}}>
                <label style={{display:"block",color:"#ffffff",fontSize:13,fontFamily:"Syne,sans-serif",fontWeight:700,marginBottom:8}}>Transaction ID <span style={{color:"#CE1126"}}>*</span></label>
                <input type="text" placeholder="e.g. 1234567890" value={txnId} onChange={e=>setTxnId(e.target.value)} style={{
                  width:"100%",padding:"13px 16px",borderRadius:8,fontSize:14,
                  background:"rgba(255,255,255,.08)",color:"#ffffff",
                  border:txnId.trim().length>=4?"2px solid #006B3F":"2px solid rgba(255,255,255,.2)",
                  fontFamily:"Syne,sans-serif",outline:"none",boxSizing:"border-box"
                }}/>
              </div>
            )}

            {method&&(
              <label style={{display:"flex",alignItems:"flex-start",gap:12,cursor:"pointer",marginBottom:16,background:"rgba(255,255,255,.05)",padding:"12px 14px",borderRadius:8,border:"1px solid rgba(255,255,255,.1)"}}>
                <input type="checkbox" checked={confirmed} onChange={e=>setConf(e.target.checked)} style={{width:18,height:18,marginTop:1,flexShrink:0}}/>
                <span style={{color:"rgba(255,255,255,.85)",fontSize:13,lineHeight:1.65}}>
                  I confirm I have sent <strong style={{color:"#F5C842"}}>GH₵200</strong> and my transaction ID is <strong style={{color:"#F5C842"}}>{txnId||"..."}</strong>
                </span>
              </label>
            )}

            <button onClick={()=>{if(canSubmit)onPay(txnId,method,null);}} style={{
              width:"100%",padding:"16px",borderRadius:10,fontSize:15,
              fontFamily:"Syne,sans-serif",fontWeight:800,letterSpacing:".06em",
              textTransform:"uppercase",border:"none",cursor:canSubmit?"pointer":"not-allowed",
              background:canSubmit?"linear-gradient(135deg,#C9991A,#F5C842)":"rgba(255,255,255,.1)",
              color:canSubmit?"#0f1923":"rgba(255,255,255,.35)",transition:"all .2s",
              boxShadow:canSubmit?"0 4px 20px rgba(201,153,26,.4)":"none"
            }}>
              {!method?"Select a Payment Method":!canSubmit?"Enter Transaction ID & Confirm":"Confirm Manual Payment →"}
            </button>
          </div>
        )}

        <p style={{fontSize:12,color:"rgba(255,255,255,.45)",marginTop:20,textAlign:"center"}}>🔒 Secured by Hubtel · Need help? taxreliefgh@gmail.com</p>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// CUSTOMER DASHBOARD
// ═══════════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════════
// CUSTOMER MESSAGE BOX — real-time messages between client and admin
// ═══════════════════════════════════════════════════════════════════════════
function CustMsgBox({app,user,onRefresh}){
  const [msgs,setMsgs]       = useState(app?.messages||[]);
  const [reply,setReply]     = useState("");
  const [sending,setSending] = useState(false);
  const [unread,setUnread]   = useState(0);
  const bottomRef = useRef(null);

  // Poll Firebase every 8 seconds for new messages
  useEffect(()=>{
    setMsgs(app?.messages||[]);
  },[app]);

  useEffect(()=>{
    const u=(msgs||[]).filter(m=>m.from==="admin"&&!m.read).length;
    setUnread(u);
    if(u>0&&onRefresh) onRefresh();
  },[msgs]);

  useEffect(()=>{
    if(bottomRef.current)bottomRef.current.scrollIntoView({behavior:"smooth"});
  },[msgs]);

  const sendReply=async()=>{
    if(!reply.trim()||sending)return;
    setSending(true);
    const db=getDatabase();
    const existing=app?.messages||[];
    const newMsg={text:reply.trim(),date:new Date().toISOString(),from:"client",senderName:user?.name||user?.username,read:false};
    const updated=[...existing,newMsg];
    try{
        await set(dbRef(db,`applications/${app.id}/messages`),updated);
      setMsgs(updated);
      setReply("");
    }catch(e){console.error(e);}
    setSending(false);
  };

  const ADMIN_WA = "https://wa.me/233243911216?text=Hello%2C%20I%20need%20help%20with%20my%20TaxReliefGH%20application%20" + encodeURIComponent(app?.id||"");

  return(
    <div className="icard" style={{border:"2px solid #006B3F",padding:0,overflow:"hidden"}}>
      {/* Header */}
      <div style={{background:"#006B3F",padding:"14px 18px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:22}}>💬</span>
          <div>
            <p style={{margin:0,fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:15,color:"#fff"}}>Messages</p>
            <p style={{margin:0,fontSize:11,color:"rgba(255,255,255,.7)"}}>Chat with TaxReliefGH team</p>
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          {unread>0&&(
            <span style={{background:"#dc2626",color:"#fff",borderRadius:12,padding:"3px 10px",fontSize:12,fontWeight:700}}>
              {unread} new
            </span>
          )}
          <a href={ADMIN_WA} target="_blank" rel="noopener noreferrer" style={{
            display:"flex",alignItems:"center",gap:6,background:"#25D366",
            color:"#fff",borderRadius:8,padding:"7px 14px",fontSize:12,
            fontFamily:"Syne,sans-serif",fontWeight:700,textDecoration:"none"
          }}>
            <span style={{fontSize:16}}>📱</span> WhatsApp
          </a>
        </div>
      </div>

      {/* Messages list */}
      <div style={{maxHeight:320,overflowY:"auto",padding:"14px 16px",background:"var(--bg)",display:"flex",flexDirection:"column",gap:10}}>
        {(!msgs||msgs.length===0)&&(
          <div style={{textAlign:"center",padding:"28px 0",color:"var(--muted)"}}>
            <p style={{fontSize:28,margin:"0 0 8px"}}>💬</p>
            <p style={{fontSize:13,fontFamily:"Syne,sans-serif"}}>No messages yet. Send us a message below or WhatsApp us directly.</p>
          </div>
        )}
        {(msgs||[]).map((msg,i)=>{
          const isAdmin=msg.from==="admin"||msg.from==="developer"||msg.from==="settlers";
          return(
            <div key={i} style={{display:"flex",flexDirection:"column",alignItems:isAdmin?"flex-start":"flex-end"}}>
              <div style={{
                maxWidth:"82%",padding:"10px 14px",borderRadius:isAdmin?"4px 14px 14px 14px":"14px 4px 14px 14px",
                background:isAdmin?"#f0fdf4":"#006B3F",
                border:isAdmin?"1.5px solid #86efac":"none",
                boxShadow:"0 1px 4px rgba(0,0,0,.08)"
              }}>
                <p style={{margin:"0 0 4px",fontSize:11,fontWeight:700,color:isAdmin?"#006B3F":"rgba(255,255,255,.8)",fontFamily:"Syne,sans-serif"}}>
                  {isAdmin?"🔒 Admin Team":"👤 You"}
                </p>
                <p style={{margin:0,fontSize:14,color:isAdmin?"#0f1923":"#fff",lineHeight:1.6,fontWeight:500}}>{msg.text}</p>
                <p style={{margin:"4px 0 0",fontSize:10,color:isAdmin?"#555":"rgba(255,255,255,.6)",textAlign:"right"}}>
                  {new Date(msg.date).toLocaleDateString("en-GB",{day:"numeric",month:"short"})} {new Date(msg.date).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"})}
                </p>
              </div>
            </div>
          );
        })}
        <div ref={bottomRef}/>
      </div>

      {/* Reply box */}
      <div style={{padding:"12px 16px",borderTop:"1px solid var(--border)",background:"var(--card)",display:"flex",gap:10,alignItems:"flex-end"}}>
        <textarea
          placeholder="Type your message to admin..."
          value={reply}
          onChange={e=>setReply(e.target.value)}
          onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendReply();}}}
          rows={2}
          style={{
            flex:1,padding:"10px 12px",borderRadius:10,border:"1.5px solid var(--border)",
            background:"var(--bg)",color:"var(--ink)",fontSize:14,fontFamily:"Lora,serif",
            resize:"none",outline:"none",lineHeight:1.5
          }}
        />
        <button onClick={sendReply} disabled={sending||!reply.trim()} style={{
          padding:"10px 18px",borderRadius:10,border:"none",
          background:reply.trim()?"#006B3F":"var(--border)",
          color:reply.trim()?"#fff":"var(--muted)",
          fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13,
          cursor:reply.trim()?"pointer":"not-allowed",flexShrink:0,
          transition:"all .15s"
        }}>{sending?"...":"Send ➤"}</button>
      </div>
      <p style={{margin:0,padding:"8px 16px 12px",fontSize:11,color:"var(--muted)",textAlign:"center"}}>
        Messages are saved to your application. You also received an SMS notification when admin replies.
      </p>
    </div>
  );
}

function CustDash({user,app,setPage,onRefresh,onDocsUpdate}){
  const [showContact,setShowContact]=useState(false);
  const [cSubject,setCSubject]=useState("");
  const [cMsg,setCMsg]=useState("");
  const [cSent,setCSent]=useState(false);
  const [showDocs,setShowDocs]=useState(false);
  const [docFiles,setDocFiles]=useState([]);
  const [docUploading,setDocUploading]=useState(false);
  const [docMsg,setDocMsg]=useState("");
  const [docSaved,setDocSaved]=useState(false);
  // Refresh data from Firebase every time dashboard is opened
  useEffect(()=>{if(onRefresh)onRefresh();},[]);
  if(!app)return(
    <div className="dash" style={{textAlign:"center",paddingTop:80}}>
      <div style={{fontSize:50}}>📋</div>
      <h2 style={{color:"var(--ink)",marginTop:12}}>No Application Yet</h2>
      <p style={{color:"var(--muted)",margin:"12px 0 22px",fontSize:14}}>Start your Tax Relief application now.</p>
      <button className="bsub" onClick={()=>setPage("form")}>Start Application</button>
    </div>
  );
  const ci=STATUS_STEPS.findIndex(s=>s.key===app.status);
  return(
    <div className="dash">
      <div className="dash-hd" style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
        <div><h2>My Application</h2><p>TaxReliefGH · <strong style={{color:"var(--ink)"}}>{app.id}</strong></p></div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {app.status!=="completed"&&(
            <button onClick={()=>setPage("form")} style={{
              background:["submitted","payment_pending","awaiting_approval"].includes(app.status)?"#1a56db":"#006B3F",
              color:"#fff",border:"none",padding:"10px 18px",
              borderRadius:8,cursor:"pointer",fontFamily:"Syne,sans-serif",
              fontWeight:700,fontSize:13,display:"flex",alignItems:"center",gap:7
            }}>
              {["submitted","payment_pending","awaiting_approval"].includes(app.status)?"✏️ Edit Application":"📎 Add / Update Documents"}
            </button>
          )}
          {app.status!=="completed"&&(
            <button onClick={()=>setShowDocs(true)} style={{
              background:"#006B3F",color:"#fff",border:"none",padding:"10px 18px",
              borderRadius:8,cursor:"pointer",fontFamily:"Syne,sans-serif",
              fontWeight:700,fontSize:13,display:"flex",alignItems:"center",gap:7
            }}>📎 Upload Documents</button>
          )}
        </div>
      </div>
      {["approved","processing"].includes(app.status)&&(
        <div style={{
          background:"linear-gradient(135deg,#e6f4ed,#f0faf4)",
          border:"2px solid #006B3F",borderRadius:12,
          padding:"16px 20px",marginBottom:16,
          display:"flex",alignItems:"flex-start",gap:14
        }}>
          <span style={{fontSize:28,flexShrink:0}}>📎</span>
          <div>
            <p style={{fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:14,color:"#006B3F",margin:"0 0 4px"}}>
              Need to add or update documents?
            </p>
            <p style={{fontSize:13,color:"#374151",margin:"0 0 10px",lineHeight:1.6}}>
              Click <strong>"📎 Add / Update Documents"</strong> above to attach your files. They will be sent directly to our Google Drive for the admin to download and review.
            </p>
          </div>
        </div>
      )}

      {app.status==="awaiting_approval"&&(
        <div style={{background:"linear-gradient(135deg,#fef3c7,#fffbeb)",border:"2px solid #f59e0b",borderRadius:12,padding:"20px 24px",marginBottom:20,display:"flex",gap:16,alignItems:"flex-start"}}>
          <span style={{fontSize:36,flexShrink:0}}>⏳</span>
          <div>
            <h3 style={{color:"#92400e",fontFamily:"Syne,sans-serif",marginBottom:6}}>Payment Submitted — Awaiting Approval</h3>
            <p style={{color:"#78350f",fontSize:13,lineHeight:1.7}}>We have received your payment submission. Our admin is verifying your transaction ID. This usually takes a few hours. You will see your status update here once approved.</p>
          </div>
        </div>
      )}
      {app.status==="approved"&&(
        <div style={{background:"linear-gradient(135deg,#e6f4ed,#f0faf4)",border:"2px solid #006B3F",borderRadius:12,padding:"20px 24px",marginBottom:20,display:"flex",gap:16,alignItems:"flex-start"}}>
          <span style={{fontSize:36,flexShrink:0}}>✅</span>
          <div>
            <h3 style={{color:"#006B3F",fontFamily:"Syne,sans-serif",marginBottom:6}}>Payment Approved!</h3>
            <p style={{color:"#004d2c",fontSize:13,lineHeight:1.7}}>Your payment has been verified. Your application is now queued for processing by our Settlers agent.</p>
          </div>
        </div>
      )}
      {app.status==="processing"&&(
        <div style={{background:"linear-gradient(135deg,#fff3e0,#fff8f0)",border:"2px solid #e65100",borderRadius:12,padding:"20px 24px",marginBottom:20,display:"flex",gap:16,alignItems:"flex-start"}}>
          <span style={{fontSize:36,flexShrink:0}}>⚙️</span>
          <div>
            <h3 style={{color:"#e65100",fontFamily:"Syne,sans-serif",marginBottom:6}}>Application Being Processed</h3>
            <p style={{color:"#9a3412",fontSize:13,lineHeight:1.7}}>Settlers agent is actively working on your application. Processing takes 4–8 weeks. You will be notified once completed.</p>
          </div>
        </div>
      )}
      {app.status==="completed"&&(
        <div className="cbanner"><div style={{fontSize:42,flexShrink:0}}>🎉</div>
          <div><h3>Application Completed!</h3><p>Your Tax Relief has been processed. It will reflect on your payslip from January of the next tax year.</p></div>
        </div>
      )}
      <div className="icard">
        <div className="igrid">
          {[["App ID",app.id],["Name",user.name],["Username",user.username||"—"],["Region",user.region],["Town",user.town||"—"],["Status",null],["Transaction ID",(app.transactionId||"Not yet submitted")+(app.paymentVerified?" ✅ Hubtel Verified":"")],["Payment Method",app.paymentMethod||"—"],["Submitted",new Date(app.submittedAt).toLocaleDateString("en-GB")],...(app.paymentSubmittedAt?[["Payment Sent",new Date(app.paymentSubmittedAt).toLocaleDateString("en-GB")]]:[])]
          .map(([l,v])=>(<div key={l} className="ii"><div className="lbl">{l}</div><div className="val">{l==="Status"?<SBadge s={app.status}/>:v}</div></div>))}
        </div>
      </div>
      <div className="icard">
        <h3 style={{fontSize:16,color:"var(--ink)",marginBottom:22,fontFamily:"Syne,sans-serif"}}>Application Progress</h3>
        {STATUS_STEPS.map((step,i)=>{
          const done=i<ci;const active=i===ci;
          return(
            <div key={step.key} className="tl-step">
              <div className={`tldot${done?" done":active?" active":""}`}>{done?"✓":active?"●":"○"}</div>
              <div className="tl-content">
                <h4 style={{color:done||active?"var(--ink)":"#bbb"}}>{step.ico} {step.label}</h4>
                <p>{step.desc}</p>
                {active&&app.status==="payment_pending"&&(
                  <button className="bsub" style={{marginTop:9,padding:"8px 20px",fontSize:12}} onClick={()=>setPage("payment")}>Pay GH₵200 Now →</button>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <CustMsgBox app={app} user={user} onRefresh={onRefresh}/>
      {app.feedbacks?.length>0&&(
        <div className="icard"><h3 style={{fontSize:16,color:"var(--ink)",marginBottom:13,fontFamily:"Syne,sans-serif"}}>📨 Updates from Settlers</h3>
          {app.feedbacks.map((fb,i)=>(<div key={i} className="fbcard"><h4>Settlers Agent · {new Date(fb.date).toLocaleDateString("en-GB")}</h4><p>{fb.text}</p></div>))}
        </div>
      )}

      {/* ── Upload Documents Modal ── */}
      {showDocs&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.65)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:16}}
          onClick={()=>{if(!docUploading)setShowDocs(false);}}>
          <div style={{background:"var(--card)",borderRadius:16,width:"100%",maxWidth:520,padding:"28px 28px 24px",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}
            onClick={e=>e.stopPropagation()}>

            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:18}}>
              <div>
                <h3 style={{fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:18,color:"var(--ink)",margin:0}}>📎 Upload Documents</h3>
                <p style={{fontSize:12,color:"var(--muted)",marginTop:3}}>Add or replace documents on your application</p>
              </div>
              {!docUploading&&<button onClick={()=>setShowDocs(false)} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",color:"var(--muted)"}}>✕</button>}
            </div>

            {docSaved?(
              <div style={{textAlign:"center",padding:"24px 0"}}>
                <div style={{fontSize:52,marginBottom:10}}>✅</div>
                <h4 style={{fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:17,color:"var(--ink)",marginBottom:8}}>Documents Uploaded!</h4>
                <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.6,marginBottom:20}}>Your documents have been saved. The admin will be able to download them shortly.</p>
                <button onClick={()=>{setShowDocs(false);setDocSaved(false);setDocFiles([]);setDocMsg("");}} style={{
                  background:"#006B3F",color:"#fff",border:"none",padding:"12px 28px",
                  borderRadius:8,cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:14
                }}>Done ✓</button>
              </div>
            ):(
              <div>
                {/* Current docs */}
                {docFiles.length>0&&(
                  <div style={{marginBottom:14}}>
                    <p style={{fontSize:11,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".08em",marginBottom:8,fontWeight:700}}>Selected Files ({docFiles.length})</p>
                    <div style={{display:"flex",flexDirection:"column",gap:6}}>
                      {docFiles.map((f,i)=>(
                        <div key={i} style={{display:"flex",alignItems:"center",justifyContent:"space-between",background:"#f0faf4",border:"1.5px solid #b3dfc5",borderRadius:8,padding:"9px 12px",gap:8}}>
                          <div style={{display:"flex",alignItems:"center",gap:8,flex:1,minWidth:0}}>
                            <span style={{fontSize:16}}>{f.driveUrl?"☁️":/\.(jpg|jpeg|png|gif|webp)$/i.test(f.name)?"🖼️":"📄"}</span>
                            <div style={{minWidth:0}}>
                              <p style={{fontSize:13,fontWeight:700,color:"var(--ink)",margin:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.name}</p>
                              <p style={{fontSize:10,color:"#006B3F",margin:0,fontWeight:600}}>{f.driveUrl?"☁️ Google Drive":f.data?`✅ ${Math.round(f.data.length*.75/1024)}KB`:"ready"}</p>
                            </div>
                          </div>
                          <button onClick={()=>setDocFiles(p=>p.filter((_,j)=>j!==i))} style={{background:"#fee2e2",border:"none",color:"#dc2626",cursor:"pointer",fontSize:12,borderRadius:6,padding:"4px 8px",fontWeight:700}}>✕</button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Upload area */}
                <div
                  onClick={()=>!docUploading&&document.getElementById("doc-upload-input").click()}
                  style={{
                    border:"2px dashed var(--border)",borderRadius:10,padding:"22px",
                    textAlign:"center",cursor:docUploading?"not-allowed":"pointer",
                    background:"var(--bg)",marginBottom:14,
                    opacity:docUploading?0.6:1
                  }}>
                  <div style={{fontSize:30,marginBottom:6}}>{docUploading?"⏳":"📎"}</div>
                  <p style={{fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--ink)",fontSize:13,margin:"0 0 4px"}}>
                    {docUploading?docMsg:"Click to select files"}
                  </p>
                  <p style={{fontSize:11,color:"var(--muted)",margin:0}}>Photos (JPG/PNG) or PDFs up to 4MB</p>
                  <input id="doc-upload-input" type="file" multiple accept="image/*,.pdf,.doc,.docx" style={{display:"none"}}
                    onChange={async(e)=>{
                      const files=Array.from(e.target.files);
                      if(!files.length)return;
                      setDocUploading(true);
                      const results=[];
                      const scriptUrl=window.__GDRIVE_SCRIPT_URL__||"";
                      for(let i=0;i<files.length;i++){
                        const file=files[i];
                        setDocMsg(`Processing ${i+1}/${files.length}: ${file.name}...`);
                        try{
                          const isImage=/^image\//i.test(file.type);
                          let b64="";
                          if(isImage){
                            b64=await new Promise(res=>{
                              const img=new Image();const url=URL.createObjectURL(file);
                              img.onload=()=>{
                                URL.revokeObjectURL(url);
                                const MAX=800;let w=img.width,h=img.height;
                                if(w>MAX){h=Math.round(h*MAX/w);w=MAX;}
                                if(h>MAX){w=Math.round(w*MAX/h);h=MAX;}
                                const c=document.createElement("canvas");c.width=w;c.height=h;
                                c.getContext("2d").drawImage(img,0,0,w,h);
                                res(c.toDataURL("image/jpeg",0.65));
                              };
                              img.onerror=()=>{URL.revokeObjectURL(url);res("");};
                              img.src=url;
                            });
                          } else {
                            if(file.size>4*1024*1024){setDocMsg(`⚠️ ${file.name} too large (max 4MB)`);await new Promise(r=>setTimeout(r,2000));continue;}
                            b64=await new Promise((res,rej)=>{const rd=new FileReader();rd.onload=ev=>res(ev.target.result);rd.onerror=rej;rd.readAsDataURL(file);});
                          }
                          // Try Google Drive first
                          if(scriptUrl&&scriptUrl.includes("script.google.com/macros")){
                            setDocMsg(`☁️ Uploading to Drive: ${file.name}...`);
                            try{
                              const resp=await fetch(scriptUrl,{method:"POST",body:JSON.stringify({name:file.name,type:file.type||"application/octet-stream",data:b64})});
                              const result=JSON.parse(await resp.text());
                              if(result.success&&result.url){
                                results.push({name:file.name,type:file.type,driveUrl:result.url,viewUrl:result.viewUrl||result.url,driveId:result.id||""});
                                setDocMsg(`☁️ ${file.name} saved to Drive ✓`);
                                continue;
                              }
                            }catch(de){console.warn("Drive failed:",de.message);}
                          }
                          results.push({name:file.name,type:file.type,data:b64});
                          setDocMsg(`✅ ${file.name} ready`);
                        }catch(err){setDocMsg(`❌ Failed: ${file.name}`);}
                      }
                      setDocFiles(p=>[...p,...results]);
                      setDocUploading(false);
                      setDocMsg("");
                      e.target.value="";
                    }}
                  />
                </div>

                {docMsg&&!docUploading&&(
                  <p style={{fontSize:12,color:"#006B3F",fontWeight:600,marginBottom:10,textAlign:"center"}}>{docMsg}</p>
                )}

                <div style={{display:"flex",gap:10}}>
                  <button
                    disabled={docFiles.length===0||docUploading}
                    onClick={async()=>{
                      if(!docFiles.length)return;
                      setDocUploading(true);
                      setDocMsg("Saving documents to your application...");
                      // Load existing files then merge
                      const existing=await dbH.getFiles(app.id)||[];
                      const existingNames=existing.map(f=>f.name);
                      const merged=[...existing,...docFiles.filter(f=>!existingNames.includes(f.name))];
                      // Save each new file to Firebase /uploads/
                      for(let i=0;i<merged.length;i++){
                        if(merged[i].data||merged[i].driveUrl){
                          await dbH.saveFile(app.id,i,merged[i]);
                        }
                      }
                      // Update app metadata
                      const fileMeta=merged.map((f,i)=>({name:f.name,type:f.type||"",index:i,driveUrl:f.driveUrl||""}));
                      const updatedData={...(app.data||{}),attachedFiles:fileMeta};
                      await dbH.updateApp(app.id,{data:updatedData,fileCount:merged.length,lastDocUpdate:new Date().toISOString()});
                      if(onDocsUpdate)onDocsUpdate();
                      setDocUploading(false);
                      setDocSaved(true);
                    }}
                    style={{
                      flex:1,background:docFiles.length>0?"#006B3F":"#ccc",color:"#fff",border:"none",
                      padding:"13px",borderRadius:8,cursor:docFiles.length>0?"pointer":"not-allowed",
                      fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:14
                    }}>
                    {docUploading?"Saving...":"💾 Save Documents"}
                  </button>
                  <button onClick={()=>{if(!docUploading){setShowDocs(false);setDocFiles([]);setDocMsg("");}}} style={{
                    padding:"13px 20px",background:"var(--border)",color:"var(--ink)",border:"none",
                    borderRadius:8,cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13
                  }}>Cancel</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Contact Support Button ── */}
      <div style={{marginTop:32,borderTop:"1px solid var(--border)",paddingTop:24}}>
        <div style={{
          background:"linear-gradient(135deg,#0f1923,#1a2a3a)",
          border:"1.5px solid #2a3f55",
          borderRadius:14,padding:"20px 24px",
          display:"flex",alignItems:"center",justifyContent:"space-between",
          flexWrap:"wrap",gap:14
        }}>
          <div style={{display:"flex",alignItems:"center",gap:14}}>
            <div style={{width:46,height:46,borderRadius:12,background:"rgba(245,200,66,.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>✉️</div>
            <div>
              <p style={{fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:14,color:"#fff",margin:0}}>Need Help?</p>
              <p style={{fontSize:12,color:"rgba(255,255,255,.55)",margin:"3px 0 0"}}>Contact our support team for any issues with your application</p>
            </div>
          </div>
          <button onClick={()=>{setShowContact(true);setCSent(false);setCSubject(app?`Re: Application ${app.id}`:"Application Support");setCMsg("");}} style={{
            background:"#F5C842",color:"#0f1923",border:"none",
            padding:"11px 22px",borderRadius:8,cursor:"pointer",
            fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:13,
            whiteSpace:"nowrap",flexShrink:0
          }}>✉️ Contact Support</button>
        </div>
      </div>

      {/* ── Contact Support Modal ── */}
      {showContact&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.65)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:"16px"}}
          onClick={()=>setShowContact(false)}>
          <div style={{background:"var(--card)",borderRadius:16,width:"100%",maxWidth:500,padding:"28px 28px 24px",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}
            onClick={e=>e.stopPropagation()}>

            {/* Header */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
              <div>
                <h3 style={{fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:18,color:"var(--ink)",margin:0}}>Contact Support</h3>
                <p style={{fontSize:12,color:"var(--muted)",marginTop:3}}>We'll respond within 24 hours</p>
              </div>
              <button onClick={()=>setShowContact(false)} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",color:"var(--muted)",lineHeight:1}}>✕</button>
            </div>

            {cSent?(
              /* ── Success state ── */
              <div style={{textAlign:"center",padding:"24px 0"}}>
                <div style={{fontSize:56,marginBottom:12}}>✅</div>
                <h4 style={{fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:17,color:"var(--ink)",marginBottom:8}}>Email Client Opened!</h4>
                <p style={{fontSize:13,color:"var(--muted)",lineHeight:1.6,marginBottom:18}}>
                  Your email app should have opened with the message ready to send.<br/>
                  If it didn't open, email us directly at:
                </p>
                <a href="mailto:taxreliefgh@gmail.com" style={{
                  display:"inline-block",background:"#F5C842",color:"#0f1923",
                  padding:"10px 22px",borderRadius:8,fontFamily:"Syne,sans-serif",
                  fontWeight:800,fontSize:13,textDecoration:"none"
                }}>taxreliefgh@gmail.com</a>
                <div style={{marginTop:20}}>
                  <button onClick={()=>setShowContact(false)} style={{
                    background:"var(--border)",color:"var(--ink)",border:"none",
                    padding:"10px 24px",borderRadius:8,cursor:"pointer",
                    fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13
                  }}>Close</button>
                </div>
              </div>
            ):(
              /* ── Form state ── */
              <div>
                {/* To field (read-only) */}
                <div style={{marginBottom:14}}>
                  <label style={{fontSize:11,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".08em",display:"block",marginBottom:5}}>To</label>
                  <div style={{
                    background:"var(--bg)",border:"1.5px solid var(--border)",
                    borderRadius:8,padding:"10px 14px",fontSize:13,
                    color:"var(--ink)",fontWeight:600,display:"flex",alignItems:"center",gap:8
                  }}>
                    <span style={{fontSize:16}}>📧</span> taxreliefgh@gmail.com
                  </div>
                </div>

                {/* From (auto-filled) */}
                <div style={{marginBottom:14}}>
                  <label style={{fontSize:11,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".08em",display:"block",marginBottom:5}}>From</label>
                  <div style={{
                    background:"var(--bg)",border:"1.5px solid var(--border)",
                    borderRadius:8,padding:"10px 14px",fontSize:13,color:"var(--muted)"
                  }}>
                    {user.name} ({user.username||user.email||"client"})
                  </div>
                </div>

                {/* Subject */}
                <div style={{marginBottom:14}}>
                  <label style={{fontSize:11,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".08em",display:"block",marginBottom:5}}>Subject</label>
                  <input
                    className="fi"
                    value={cSubject}
                    onChange={e=>setCSubject(e.target.value)}
                    placeholder="e.g. Issue with my application"
                    style={{width:"100%",fontSize:13}}
                  />
                </div>

                {/* Message */}
                <div style={{marginBottom:20}}>
                  <label style={{fontSize:11,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".08em",display:"block",marginBottom:5}}>Message</label>
                  <textarea
                    className="fi"
                    value={cMsg}
                    onChange={e=>setCMsg(e.target.value)}
                    rows={5}
                    placeholder={`Hi TaxReliefGH support,

I need help with my application ${app?.id||""}.

`}
                    style={{width:"100%",fontSize:13,resize:"vertical",minHeight:130,fontFamily:"inherit"}}
                  />
                </div>

                {/* App reference banner */}
                {app&&(
                  <div style={{
                    background:"#f0f4ff",border:"1px solid #c0ccf0",borderRadius:8,
                    padding:"9px 14px",marginBottom:18,fontSize:12,color:"#3b5bdb",
                    display:"flex",alignItems:"center",gap:8
                  }}>
                    <span>ℹ️</span>
                    <span>Your App ID <strong>{app.id}</strong> and name will be included automatically</span>
                  </div>
                )}

                {/* Buttons */}
                <div style={{display:"flex",gap:10}}>
                  <button
                    onClick={()=>{
                      if(!cMsg.trim()){alert("Please type a message first.");return;}
                      const fullMsg=`${cMsg}

---
Client: ${user.name}
Username: ${user.username||"—"}
App ID: ${app?.id||"N/A"}
Status: ${app?.status||"N/A"}
Region: ${user.region||"—"}, ${user.town||"—"}`;
                      const mailto=`mailto:taxreliefgh@gmail.com?subject=${encodeURIComponent(cSubject||"Support Request")}&body=${encodeURIComponent(fullMsg)}`;
                      window.open(mailto,"_self");
                      setCSent(true);
                    }}
                    style={{
                      flex:1,background:"#F5C842",color:"#0f1923",border:"none",
                      padding:"13px",borderRadius:8,cursor:"pointer",
                      fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:14
                    }}
                    disabled={!cMsg.trim()}
                  >
                    📤 Send Email
                  </button>
                  <button onClick={()=>setShowContact(false)} style={{
                    flex:"0 0 auto",padding:"13px 20px",background:"var(--border)",
                    color:"var(--ink)",border:"none",borderRadius:8,
                    cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13
                  }}>Cancel</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// DEV DASHBOARD
// ═══════════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════════
// DEVELOPER EDIT MODAL — edit any application fields before sending to admin
// ═══════════════════════════════════════════════════════════════════════════
function DevEditModal({app,onSave,onClose}){
  const d = app.data || {};
  const [f,setF] = useState({
    surname:          d.surname||"",
    otherNames:       d.otherNames||"",
    telephone:        d.telephone||"",
    email:            d.email||"",
    ghanaCardNo:      d.ghanaCardNo||"",
    staffId:          d.staffId||"",
    dateOfBirth:      d.dateOfBirth||"",
    region:           d.region||"",
    town:             d.town||"",
    employer:         d.employer||"",
    sector:           d.sector||"",
    maritalStatus:    d.maritalStatus||"",
    spouseName:       d.spouseName||"",
    spouseDob:        d.spouseDob||"",
    spouseGhanaCard:  d.spouseGhanaCard||"",
    spouseSsnit:      d.spouseSsnit||"",
    numChildren:      d.numChildren||"0",
    bankName:         d.bankName||"",
    bankBranch:       d.bankBranch||"",
    accountNumber:    d.accountNumber||"",
    tin:              d.tin||"",
    disabled:         d.disabled||"no",
    disabilityType:   d.disabilityType||"",
  });
  const [saving,setSaving] = useState(false);
  const sf=(k,v)=>setF(p=>({...p,[k]:v}));

  const FIELD=({label,k,type="text",placeholder=""})=>(
    <div style={{display:"flex",flexDirection:"column",gap:4}}>
      <label style={{fontSize:12,fontWeight:700,color:"var(--muted)",fontFamily:"Syne,sans-serif",textTransform:"uppercase",letterSpacing:".05em"}}>{label}</label>
      <input type={type} value={f[k]} placeholder={placeholder}
        onChange={e=>sf(k,e.target.value)}
        style={{padding:"9px 12px",borderRadius:7,border:"1.5px solid var(--border)",
          background:"var(--bg)",color:"var(--ink)",fontSize:14,fontFamily:"Lora,serif",
          outline:"none",width:"100%",boxSizing:"border-box"}}/>
    </div>
  );

  const SECTION=({title})=>(
    <div style={{gridColumn:"1/-1",borderBottom:"2px solid var(--green)",paddingBottom:4,marginTop:8}}>
      <span style={{fontSize:12,fontWeight:800,color:"var(--green)",fontFamily:"Syne,sans-serif",textTransform:"uppercase",letterSpacing:".08em"}}>{title}</span>
    </div>
  );

  const handleSave=async()=>{
    setSaving(true);
    await onSave(f);
    setSaving(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.65)",zIndex:99998,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"var(--card)",borderRadius:16,width:"100%",maxWidth:780,maxHeight:"90vh",overflow:"auto",boxShadow:"0 20px 60px rgba(0,0,0,.35)"}}>
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"18px 24px",borderBottom:"1px solid var(--border)",position:"sticky",top:0,background:"var(--card)",zIndex:2}}>
          <div>
            <p style={{margin:0,fontSize:18,fontWeight:800,color:"var(--ink)",fontFamily:"Syne,sans-serif"}}>✏️ Edit Application</p>
            <p style={{margin:0,fontSize:12,color:"var(--muted)",fontFamily:"Syne,sans-serif"}}>{app.id} · {d.surname} {d.otherNames}</p>
          </div>
          <div style={{display:"flex",gap:10}}>
            <button onClick={handleSave} disabled={saving} style={{
              padding:"9px 22px",borderRadius:8,border:"none",cursor:saving?"not-allowed":"pointer",
              background:saving?"var(--border)":"var(--green)",color:"#fff",
              fontSize:13,fontFamily:"Syne,sans-serif",fontWeight:700
            }}>{saving?"Saving…":"💾 Save Changes"}</button>
            <button onClick={onClose} style={{
              padding:"9px 16px",borderRadius:8,border:"1.5px solid var(--border)",
              background:"none",cursor:"pointer",fontSize:13,color:"var(--muted)",fontFamily:"Syne,sans-serif"
            }}>Cancel</button>
          </div>
        </div>

        {/* Form grid */}
        <div style={{padding:"20px 24px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
          <SECTION title="Personal Information"/>
          <FIELD label="Surname"        k="surname"/>
          <FIELD label="Other Names"    k="otherNames"/>
          <FIELD label="Telephone"      k="telephone" type="tel"/>
          <FIELD label="Email"          k="email"     type="email"/>
          <FIELD label="Ghana Card No." k="ghanaCardNo" placeholder="GHA-XXXXXXXXX-X"/>
          <FIELD label="Staff ID"       k="staffId"/>
          <FIELD label="Date of Birth"  k="dateOfBirth" type="date"/>
          <FIELD label="TIN"            k="tin"/>

          <SECTION title="Location & Employment"/>
          <FIELD label="Region"   k="region"/>
          <FIELD label="Town"     k="town"/>
          <FIELD label="Employer" k="employer"/>
          <FIELD label="Sector"   k="sector"/>

          <SECTION title="Marital & Spouse Info"/>
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            <label style={{fontSize:12,fontWeight:700,color:"var(--muted)",fontFamily:"Syne,sans-serif",textTransform:"uppercase",letterSpacing:".05em"}}>Marital Status</label>
            <select value={f.maritalStatus} onChange={e=>sf("maritalStatus",e.target.value)}
              style={{padding:"9px 12px",borderRadius:7,border:"1.5px solid var(--border)",background:"var(--bg)",color:"var(--ink)",fontSize:14,fontFamily:"Lora,serif"}}>
              <option value="">Select…</option>
              <option value="single">Single</option>
              <option value="married">Married</option>
              <option value="divorced">Divorced</option>
              <option value="widowed">Widowed</option>
            </select>
          </div>
          <FIELD label="Number of Children" k="numChildren" type="number"/>
          {(f.maritalStatus==="married")&&(<>
            <FIELD label="Spouse Name"       k="spouseName"/>
            <FIELD label="Spouse DOB"        k="spouseDob" type="date"/>
            <FIELD label="Spouse Ghana Card" k="spouseGhanaCard" placeholder="GHA-XXXXXXXXX-X"/>
            <FIELD label="Spouse SSNIT"      k="spouseSsnit" placeholder="e.g. C000123456"/>
          </>)}

          <SECTION title="Bank Details"/>
          <FIELD label="Bank Name"      k="bankName"/>
          <FIELD label="Bank Branch"    k="bankBranch"/>
          <FIELD label="Account Number" k="accountNumber"/>

          <SECTION title="Disability"/>
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            <label style={{fontSize:12,fontWeight:700,color:"var(--muted)",fontFamily:"Syne,sans-serif",textTransform:"uppercase",letterSpacing:".05em"}}>Disabled?</label>
            <select value={f.disabled} onChange={e=>sf("disabled",e.target.value)}
              style={{padding:"9px 12px",borderRadius:7,border:"1.5px solid var(--border)",background:"var(--bg)",color:"var(--ink)",fontSize:14,fontFamily:"Lora,serif"}}>
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>
          {f.disabled==="yes"&&<FIELD label="Disability Type" k="disabilityType"/>}

          {/* Save button bottom */}
          <div style={{gridColumn:"1/-1",display:"flex",justifyContent:"flex-end",gap:10,paddingTop:10,borderTop:"1px solid var(--border)"}}>
            <button onClick={onClose} style={{padding:"10px 20px",borderRadius:8,border:"1.5px solid var(--border)",background:"none",cursor:"pointer",fontSize:13,color:"var(--muted)",fontFamily:"Syne,sans-serif"}}>Cancel</button>
            <button onClick={handleSave} disabled={saving} style={{
              padding:"10px 24px",borderRadius:8,border:"none",cursor:saving?"not-allowed":"pointer",
              background:saving?"var(--border)":"var(--green)",color:"#fff",
              fontSize:14,fontFamily:"Syne,sans-serif",fontWeight:700
            }}>{saving?"Saving…":"💾 Save Changes"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}


// ═══════════════════════════════════════════════════════════════════════════
// ADMIN MESSAGE MODAL — dev/admin reads & replies to client messages
// ═══════════════════════════════════════════════════════════════════════════
function AdminMsgModal({app,onSend,onClose,senderRole}){
  const [reply,setReply]   = useState("");
  const [sending,setSending] = useState(false);
  const msgs = app?.messages||[];
  const bottomRef = useRef(null);

  useEffect(()=>{
    if(bottomRef.current) bottomRef.current.scrollIntoView({behavior:"smooth"});
  },[msgs]);

  const send=async()=>{
    if(!reply.trim()||sending) return;
    setSending(true);
    await onSend(app.id, reply.trim(), senderRole||"admin");
    setReply("");
    setSending(false);
  };

  const clientName = app?.data?.surname ? `${app.data.surname} ${app.data.otherNames||""}`.trim() : app?.userName||"Client";

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"var(--card)",borderRadius:16,width:"100%",maxWidth:580,maxHeight:"85vh",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>

        {/* Header */}
        <div style={{background:"#006B3F",borderRadius:"16px 16px 0 0",padding:"16px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <span style={{fontSize:24}}>💬</span>
            <div>
              <p style={{margin:0,fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:16,color:"#fff"}}>{clientName}</p>
              <p style={{margin:0,fontSize:11,color:"rgba(255,255,255,.7)"}}>{app.id} · {app?.data?.telephone||"No phone"}</p>
            </div>
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,.15)",border:"none",color:"#fff",width:32,height:32,borderRadius:"50%",cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
        </div>

        {/* Unread banner */}
        {msgs.filter(m=>m.from==="client"&&!m.read).length>0&&(
          <div style={{background:"#fef3c7",borderBottom:"1px solid #fde68a",padding:"8px 20px",display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
            <span style={{fontSize:14}}>🔔</span>
            <span style={{fontSize:12,fontWeight:700,color:"#92400e",fontFamily:"Syne,sans-serif"}}>
              {msgs.filter(m=>m.from==="client"&&!m.read).length} unread message{msgs.filter(m=>m.from==="client"&&!m.read).length>1?"s":""} from client
            </span>
          </div>
        )}

        {/* Messages */}
        <div style={{flex:1,overflowY:"auto",padding:"16px 20px",display:"flex",flexDirection:"column",gap:10,background:"var(--bg)"}}>
          {msgs.length===0&&(
            <div style={{textAlign:"center",padding:"40px 0",color:"var(--muted)"}}>
              <p style={{fontSize:28,margin:"0 0 8px"}}>💬</p>
              <p style={{fontSize:13,fontFamily:"Syne,sans-serif"}}>No messages yet. Send the first message below.</p>
            </div>
          )}
          {msgs.map((msg,i)=>{
            const isClient = msg.from==="client";
            return(
              <div key={i} style={{display:"flex",flexDirection:"column",alignItems:isClient?"flex-start":"flex-end"}}>
                <div style={{
                  maxWidth:"80%",padding:"10px 14px",
                  borderRadius:isClient?"4px 14px 14px 14px":"14px 4px 14px 14px",
                  background:isClient?"#f0fdf4":"#1a56db",
                  border:isClient?"1.5px solid #86efac":"none",
                  boxShadow:"0 1px 4px rgba(0,0,0,.08)"
                }}>
                  <p style={{margin:"0 0 4px",fontSize:11,fontWeight:700,color:isClient?"#006B3F":"rgba(255,255,255,.8)",fontFamily:"Syne,sans-serif"}}>
                    {isClient?`👤 ${clientName}`:`🔒 ${senderRole==="settlers"?"Settlers Team":"Admin Team"}`}
                  </p>
                  <p style={{margin:0,fontSize:14,color:isClient?"#0f1923":"#fff",lineHeight:1.6,fontWeight:500}}>{msg.text}</p>
                  <p style={{margin:"4px 0 0",fontSize:10,color:isClient?"#555":"rgba(255,255,255,.6)",textAlign:"right"}}>
                    {new Date(msg.date).toLocaleDateString("en-GB",{day:"numeric",month:"short"})} {new Date(msg.date).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"})}
                    {isClient&&!msg.read&&<span style={{marginLeft:6,color:"#dc2626",fontWeight:700}}>● NEW</span>}
                  </p>
                </div>
              </div>
            );
          })}
          <div ref={bottomRef}/>
        </div>

        {/* Reply box */}
        <div style={{padding:"12px 16px",borderTop:"1px solid var(--border)",background:"var(--card)",display:"flex",gap:10,alignItems:"flex-end",flexShrink:0,borderRadius:"0 0 16px 16px"}}>
          <textarea
            placeholder={`Reply to ${clientName}...`}
            value={reply}
            onChange={e=>setReply(e.target.value)}
            onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();send();}}}
            rows={2}
            style={{
              flex:1,padding:"10px 12px",borderRadius:10,border:"1.5px solid var(--border)",
              background:"var(--bg)",color:"var(--ink)",fontSize:14,fontFamily:"Lora,serif",
              resize:"none",outline:"none",lineHeight:1.5
            }}
          />
          <button onClick={send} disabled={sending||!reply.trim()} style={{
            padding:"10px 20px",borderRadius:10,border:"none",
            background:reply.trim()?"#1a56db":"var(--border)",
            color:reply.trim()?"#fff":"var(--muted)",
            fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13,
            cursor:reply.trim()?"pointer":"not-allowed",flexShrink:0
          }}>{sending?"...":"Send ➤"}</button>
        </div>
      </div>
    </div>
  );
}

function DevDash({apps,onApprove,onForward,onComplete,onSendMsg,onDelete,onDevEdit,videos,setVids,setModal}){
  const [vt,setVt]=useState("");
  const [editApp,setEditApp]=useState(null);  // app being edited by developer
  const [msgApp,setMsgApp]=useState(null);    // app whose messages are open
  const [vu,setVu]=useState("");
  const [toast2,setToast2]=useState("");
  const counts={
    total:    apps.length,
    needsAction: apps.filter(a=>a.status==="awaiting_approval"||(a.status==="approved"&&a.autoApproved)).length,
    inProg:   apps.filter(a=>["forwarded_to_settlers","processing"].includes(a.status)).length,
    done:     apps.filter(a=>a.status==="completed").length,
    autoAppr: apps.filter(a=>a.status==="approved"&&a.autoApproved).length,
    unreadMsgs: apps.reduce((sum,a)=>sum+((a.messages||[]).filter(m=>m.from==="client"&&!m.read).length),0),
  };

  const addVid=()=>{
    if(!vu)return;
    setVids([...videos,{title:vt||`Guide ${videos.length+1}`,url:vu,type:"link"}]);
    setVt("");setVu("");
    setToast2("Video link added!");setTimeout(()=>setToast2(""),3000);
  };

  const removeVideo=(v,i)=>{
    setVids(videos.filter((_,j)=>j!==i));
    setToast2("Video removed.");
    setTimeout(()=>setToast2(""),2000);
  };

  // Video upload handled via YouTube links only (Firebase Storage requires paid plan)
  return(
    <div className="devdash">
      {toast2&&<div style={{position:"fixed",top:18,left:"50%",transform:"translateX(-50%)",background:"var(--green)",color:"#fff",padding:"10px 24px",borderRadius:8,fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13,zIndex:9999,boxShadow:"0 4px 20px rgba(0,0,0,.2)"}}>{toast2}</div>}
      <div style={{marginBottom:26,paddingBottom:18,borderBottom:"1px solid var(--border)"}}>
        <span className="dev-tag">Developer Admin</span>
        <h2 style={{fontSize:28,color:"var(--ink)"}}>TaxReliefGH Dashboard</h2>
        <p style={{color:"var(--muted)",fontSize:13}}>Manage applications, forward to Settlers and manage video content</p>
      </div>
      <div className="srow">
        {[
          {num:counts.total,lbl:"Total Applications",col:"#006B3F"},
          {num:counts.needsAction,lbl:"Needs Your Action",col:counts.needsAction>0?"#dc2626":"#006B3F"},
          {num:counts.unreadMsgs,lbl:"Unread Client Messages",col:counts.unreadMsgs>0?"#d97706":"#374151"},
          {num:counts.autoAppr,lbl:"Auto-Approved (Hubtel)",col:"#1a56db"},
          {num:counts.inProg,lbl:"With Settlers",col:"#C9991A"},
          {num:counts.done,lbl:"Completed",col:"#374151"},
        ].map((s,i)=>(
          <div key={i} className="scard" style={{borderTop:`3px solid ${s.col}`}}>
            <div className="num" style={{color:s.col}}>{s.num}</div>
            <div className="lbl">{s.lbl}</div>
          </div>
        ))}
      </div>
      <div className="abox">
        <div className="abox-hd"><h3>All Applications ({apps.length})</h3></div>
        {apps.length===0
          ?<div style={{padding:"44px 24px",textAlign:"center",color:"var(--muted)",fontSize:14}}>No applications yet.</div>
          :<table>
            <thead><tr><th>App ID</th><th>Client</th><th>Region · Town</th><th>Status</th><th>Txn ID</th><th>Actions</th></tr></thead>
            <tbody>{apps.map(a=>(
              <tr key={a.id}>
                <td style={{fontFamily:"monospace",fontSize:10,color:"var(--muted)"}}>{a.id.slice(-8)}</td>
                <td>
                  <strong style={{fontSize:13}}>{a.userName}</strong>
                  <div style={{fontSize:10,color:"var(--muted)"}}>{a.userUsername||a.userEmail||""}</div>
                  <div style={{fontSize:10,color:"var(--muted)"}}>{new Date(a.submittedAt).toLocaleDateString("en-GB")}</div>
                </td>
                <td><span className="rid">📍 {a.userRegion}</span>{a.userTown&&<div style={{fontSize:10,color:"var(--muted)",marginTop:2}}>{a.userTown}</div>}</td>
                <td><SBadge s={a.status}/></td>
                <td style={{fontSize:12,fontFamily:"monospace",color:a.transactionId?"var(--green)":"var(--muted)"}}>{a.transactionId||"—"}</td>
                <td style={{display:"flex",flexWrap:"wrap",gap:5}}>
                  <button className="abtn ab-v" onClick={()=>setModal(a)}>👁 View</button>
                  <button className="abtn" onClick={()=>setMsgApp(a)}
                    style={{background:"#006B3F",color:"#fff",border:"none",padding:"5px 10px",borderRadius:5,cursor:"pointer",fontSize:12,fontFamily:"Syne,sans-serif",fontWeight:700,position:"relative"}}>
                    💬 Messages
                    {(a.messages||[]).filter(m=>m.from==="client"&&!m.read).length>0&&(
                      <span style={{position:"absolute",top:-6,right:-6,background:"#dc2626",color:"#fff",borderRadius:"50%",width:18,height:18,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:800}}>
                        {(a.messages||[]).filter(m=>m.from==="client"&&!m.read).length}
                      </span>
                    )}
                  </button>
                  <button className="abtn" onClick={()=>setEditApp(a)}
                    style={{background:"#1a56db",color:"#fff",border:"none",padding:"5px 10px",borderRadius:5,cursor:"pointer",fontSize:12,fontFamily:"Syne,sans-serif",fontWeight:700}}>
                    ✏️ Edit
                  </button>
                  <button className="abtn" onClick={()=>onDelete(a.id)}
                    style={{background:"#CE1126",color:"#fff",border:"none",padding:"5px 10px",borderRadius:5,cursor:"pointer",fontSize:12,fontFamily:"Syne,sans-serif",fontWeight:700}}>
                    🗑 Delete
                  </button>
                  {a.status==="awaiting_approval"&&(
                    <button className="abtn" onClick={()=>onApprove(a.id)}
                      style={{background:"#006B3F",color:"#fff",border:"none",padding:"5px 10px",borderRadius:5,cursor:"pointer",fontSize:12,fontFamily:"Syne,sans-serif",fontWeight:700}}>
                      ✅ Approve Payment
                    </button>
                  )}
                  {a.status==="approved"&&a.autoApproved&&(
                    <span style={{background:"#e8f5e9",color:"#006B3F",border:"1px solid #006B3F",padding:"4px 10px",borderRadius:5,fontSize:11,fontFamily:"Syne,sans-serif",fontWeight:700}}>
                      🤖 Auto-Approved
                    </span>
                  )}
                  {a.status==="approved"&&(
                    <button className="abtn ab-f" onClick={()=>onForward(a.id)}>
                      ⚙️ Send to Settlers
                    </button>
                  )}
                  {a.status==="processing"&&(
                    <button className="abtn ab-c" onClick={()=>onComplete(a.id)}>✔ Mark Complete</button>
                  )}
                </td>
              </tr>
            ))}</tbody>
          </table>
        }
      </div>
      <div className="vmgr">
        {/* ── Google Drive Script URL Setting ── */}
        <div style={{background:"#f0f4ff",border:"1.5px solid #4361ee",borderRadius:10,padding:"16px 18px",marginBottom:20}}>
          <p style={{fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:13,color:"#1a1a2e",marginBottom:6}}>☁️ Google Drive File Storage</p>
          <p style={{fontSize:12,color:"#555",lineHeight:1.65,marginBottom:10}}>
            After deploying your Apps Script, paste the <strong>Web App URL</strong> (ends in /exec) below. <em>Do NOT paste the Google Drive folder link.</em>
            <a href="https://script.google.com/home" target="_blank" rel="noreferrer" style={{color:"#4361ee",marginLeft:6,fontWeight:700}}>Open Apps Script →</a>
          </p>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <input
              id="gdrive-url-input"
              className="fi"
              style={{flex:"2 1 280px",fontSize:12,fontFamily:"monospace"}}
              placeholder="https://script.google.com/macros/s/AKfycby.../exec  ← paste HERE (NOT the folder link)"
              defaultValue={window.__GDRIVE_SCRIPT_URL__||""}
            />
            <button
              className="bsub"
              style={{padding:"10px 16px",whiteSpace:"nowrap",flex:"0 0 auto"}}
              onClick={async()=>{
                const url=document.getElementById("gdrive-url-input").value.trim();
                window.__GDRIVE_SCRIPT_URL__=url;
                localStorage.setItem("trgh_gdrive_url",url);
                await dbH.setDriveUrl(url);
                if(url&&!url.includes("script.google.com/macros")){
                  alert("❌ Wrong URL pasted!\n\nYou need the Apps Script Web App URL, NOT the Drive folder link.\n\nCorrect format:\nhttps://script.google.com/macros/s/AKfy.../exec\n\nIn Apps Script: Deploy → Manage deployments → copy the URL");
                  return;
                }
                alert(url?"✅ Script URL saved! All clients will now upload to Google Drive.":"Google Drive cleared.");
              }}>
              Save URL
            </button>
          </div>
          {window.__GDRIVE_SCRIPT_URL__&&(
            <p style={{fontSize:11,color:"#006B3F",marginTop:6,fontWeight:600}}>
              ✅ Google Drive active — uploads go to your Drive folder
            </p>
          )}
        </div>

        <h3>🎥 Video Content Manager</h3>
        <p style={{fontSize:12.5,color:"var(--muted)",marginBottom:14}}>Add YouTube video links to show on the homepage. Paste any YouTube URL.</p>
        <div className="vadd" style={{gap:8,flexWrap:"wrap"}}>
          <input className="fi" placeholder="Video title e.g. Understanding Tax Relief" value={vt} onChange={e=>setVt(e.target.value)} style={{flex:"1 1 200px"}}/>
          <input className="fi" placeholder="YouTube URL e.g. https://youtu.be/XXXXX" value={vu} onChange={e=>setVu(e.target.value)} style={{flex:"2 1 280px"}}/>
          <button className="bsub" style={{padding:"10px 18px",whiteSpace:"nowrap"}} onClick={addVid}>+ Add</button>
        </div>
        <div style={{marginTop:16}}>
          <p style={{fontSize:11,fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:8}}>
            {videos.length} Video{videos.length!==1?"s":""} on Homepage
          </p>
          {videos.length===0&&<p style={{fontSize:13,color:"var(--muted)"}}>No videos yet. Add a YouTube link above.</p>}
          {videos.map((v,i)=>(
            <div key={i} className="vitem">
              <div>
                <div className="vt">{v.title}</div>
                <div style={{fontSize:10,color:"var(--muted)",maxWidth:380,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v.url}</div>
              </div>
              <button className="brm" onClick={()=>removeVideo(v,i)}>🗑</button>
            </div>
          ))}
        </div>
      </div>

      {/* ── DEVELOPER EDIT MODAL ─────────────────────────────────────── */}
      {editApp&&(
        <DevEditModal
          app={editApp}
          onSave={async(newData)=>{await onDevEdit(editApp.id,newData);setEditApp(null);}}
          onClose={()=>setEditApp(null)}
        />
      )}
      {msgApp&&(
        <AdminMsgModal
          app={msgApp}
          senderRole="admin"
          onSend={async(appId,txt,role)=>{
            await onSendMsg(appId,txt,role);
            // Mark client messages as read
            const updated=apps.map(a=>{
              if(a.id===appId){
                const u={...a,messages:(a.messages||[]).map(m=>m.from==="client"?{...m,read:true}:m)};
                return u;
              }
              return a;
            });
            setMsgApp(updated.find(a=>a.id===appId)||null);
          }}
          onClose={()=>setMsgApp(null)}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// SETTLERS DASHBOARD
// ═══════════════════════════════════════════════════════════════════════════
function SetDash({apps,onUpdate,onSendMsg,fbText,setFbText,setModal}){
  const [setMsgApp,setSetMsgApp]=useState(null);
  return(
    <div className="setdash">
      <div style={{marginBottom:26,paddingBottom:18,borderBottom:"1px solid var(--border)"}}>
        <span className="set-tag">Settlers Agent Portal</span>
        <h2 style={{fontSize:28,color:"var(--ink)"}}>Applications for Processing</h2>
        <p style={{color:"var(--muted)",fontSize:13}}>Review forwarded applications and update processing status</p>
      </div>
      {apps.length===0
        ?<div style={{textAlign:"center",padding:"72px 24px",color:"var(--muted)"}}><div style={{fontSize:44,marginBottom:12}}>📭</div><p>No applications forwarded yet.</p></div>
        :apps.map(a=>(
          <div key={a.id} className="setcard">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:13,flexWrap:"wrap",gap:10}}>
              <div>
                <span style={{fontFamily:"monospace",fontSize:10,color:"var(--muted)"}}>{a.id}</span>
                <h3 style={{fontSize:18,color:"var(--ink)",fontFamily:"Syne,sans-serif"}}>{a.userName}</h3>
                <div style={{display:"flex",gap:7,flexWrap:"wrap",marginTop:4}}>
                  <span className="rid">📍 {a.userRegion}{a.userTown?` · ${a.userTown}`:""}</span>
                  <span style={{fontSize:11,color:"var(--muted)"}}>{a.sector}</span>
                </div>
              </div>
              <div style={{display:"flex",gap:7,alignItems:"center",flexWrap:"wrap"}}>
                <SBadge s={a.status}/>
                <button className="abtn ab-v" onClick={()=>setModal(a)}>Full Form</button>
                <button onClick={()=>setSetMsgApp(a)}
                  style={{background:"#006B3F",color:"#fff",border:"none",padding:"5px 12px",borderRadius:5,cursor:"pointer",fontSize:12,fontFamily:"Syne,sans-serif",fontWeight:700,position:"relative",display:"inline-flex",alignItems:"center",gap:4}}>
                  💬 Messages
                  {(a.messages||[]).filter(m=>m.from==="client"&&!m.read).length>0&&(
                    <span style={{background:"#dc2626",color:"#fff",borderRadius:12,padding:"1px 7px",fontSize:10,fontWeight:800}}>
                      {(a.messages||[]).filter(m=>m.from==="client"&&!m.read).length}
                    </span>
                  )}
                </button>
              </div>
            </div>
            <div className="igrid" style={{marginBottom:13}}>
              {[["Ghana Card",a.data?.ghanaCardNo||"—"],["Tax File",a.data?.taxFileNo||"—"],["SSNIT",a.data?.socialSecNo||"—"],["Employer",a.data?.employerName||"—"],["Marital",a.data?.maritalStatus||"—"],["Children",a.data?.numChildren||"0"],["Occupation",a.userOccupation||"—"],["Disability",a.data?.disabled==="yes"?"Yes":"No"]].map(([l,v])=>(
                <div key={l} className="ii"><div className="lbl">{l}</div><div className="val" style={{fontSize:13}}>{v}</div></div>
              ))}
            </div>
            {a.feedbacks?.length>0&&a.feedbacks.map((fb,i)=>(<div key={i} className="fbcard"><h4>Feedback · {new Date(fb.date).toLocaleDateString("en-GB")}</h4><p>{fb.text}</p></div>))}
            {a.status!=="completed"&&(
              <div style={{marginTop:11}}>
                <textarea className="fi" placeholder="Add feedback or notes for the client (optional)..." value={fbText[a.id]||""} onChange={e=>setFbText(p=>({...p,[a.id]:e.target.value}))} style={{width:"100%",minHeight:66,resize:"vertical",marginBottom:10}}/>
                <div className="setacts" style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                  {a.status==="processing"&&(
                    <button className="bset bproc" onClick={()=>onUpdate(a.id,"processing")}
                      style={{background:"#e65100",color:"#fff",border:"none",padding:"10px 18px",borderRadius:7,cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13}}>
                      ⚙️ Save Feedback
                    </button>
                  )}
                  <button onClick={()=>onUpdate(a.id,"completed")}
                    style={{background:"#006B3F",color:"#fff",border:"none",padding:"10px 22px",borderRadius:7,cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13,boxShadow:"0 3px 12px rgba(0,107,63,.3)"}}>
                    🎉 Mark as Completed
                  </button>
                </div>
              </div>
            )}
            {a.status==="completed"&&(
              <div style={{background:"#e6f4ed",border:"1.5px solid #b3dfc5",padding:"12px 16px",borderRadius:8,fontSize:13,color:"#006B3F",fontWeight:700,marginTop:10,fontFamily:"Syne,sans-serif",display:"flex",alignItems:"center",gap:8}}>
                🎉 Application completed and processed successfully.
              </div>
            )}
          </div>
        ))
      }
      {setMsgApp&&(
        <AdminMsgModal
          app={setMsgApp}
          senderRole="settlers"
          onSend={async(appId,txt,role)=>{await onSendMsg(appId,txt,role);setSetMsgApp(p=>p?({...p,messages:[...(p.messages||[]),{text:txt,date:new Date().toISOString(),from:role,read:false}]}):null);}}
          onClose={()=>setSetMsgApp(null)}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// APP MODAL
// ═══════════════════════════════════════════════════════════════════════════
function AppModal({app,onClose,onSendMsg}){
  const d=app.data||{};
  const [fetchedFiles,setFetchedFiles]=useState([]);
  const [fetchingFiles,setFetchingFiles]=useState(true);
  const [msgText,setMsgText]=useState("");
  const [msgSent,setMsgSent]=useState(false);
  const [sendingMsg,setSendingMsg]=useState(false);

  // Fetch file data from Firebase /uploads/{appId}/ when modal opens
  useEffect(()=>{
    let cancelled=false;
    (async()=>{
      setFetchingFiles(true);
      const files=await dbH.getFiles(app.id);
      if(!cancelled){
        setFetchedFiles(files&&files.length>0?files:[]);
        setFetchingFiles(false);
      }
    })();
    return()=>{cancelled=true;};
  },[app.id]);

  // Merge: use fetched (has actual data) over metadata-only entries
  const metaFiles=d.attachedFiles||[];
  const displayFiles=fetchedFiles.length>0
    ?fetchedFiles
    :metaFiles;

  const downloadFile=(file)=>{
    // Google Drive file — open download link in new tab
    if(file.driveUrl){
      window.open(file.driveUrl,"_blank");
      return;
    }
    const src=file.data||null;
    if(!src){
      alert("File not available.\nAsk the client to resubmit or attach documents again.");
      return;
    }
    const a=document.createElement("a");
    a.href=src;
    a.download=file.name||"document";
    document.body.appendChild(a);
    a.click();
    setTimeout(()=>document.body.removeChild(a),500);
  };

  const downloadAllFiles=()=>{
    const files=displayFiles.filter(f=>f&&(f.data||f.url));
    if(!files.length){alert("No downloadable files found.");return;}
    files.forEach((file,i)=>setTimeout(()=>downloadFile(file),i*700));
  };

  const printApplication=()=>{
    const ch=(d.children||[]).slice(0,parseInt(d.numChildren||0));
    const allFiles=displayFiles;
    const html=`<!DOCTYPE html>
<html><head><meta charset="UTF-8"><title>TaxReliefGH - ${app.id}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:Arial,sans-serif;color:#111;padding:32px}
  .logo{background:#0f1923;color:#F5C842;padding:12px 20px;border-radius:8px;display:inline-block;font-weight:800;font-size:18px;letter-spacing:2px;margin-bottom:20px}
  h1{font-size:22px;margin-bottom:4px}
  .sub{color:#555;font-size:13px;margin-bottom:16px}
  .badge{background:#e6f4ed;color:#006B3F;padding:4px 12px;border-radius:20px;font-size:12px;font-weight:700;display:inline-block;margin-bottom:18px}
  .section{font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#888;font-weight:700;border-bottom:2px solid #eee;padding-bottom:6px;margin:20px 0 10px}
  .grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:8px}
  .field label{font-size:10px;color:#888;text-transform:uppercase;letter-spacing:.08em;display:block;margin-bottom:2px}
  .field span{font-size:14px;font-weight:600}
  table{width:100%;border-collapse:collapse;margin-bottom:14px;font-size:13px}
  th{background:#f4f6f9;padding:7px 10px;text-align:left;font-size:11px;text-transform:uppercase;color:#555}
  td{padding:7px 10px;border-bottom:1px solid #eee}
  .txn{background:#fff8e6;border:1.5px solid #C9991A;border-radius:8px;padding:12px 16px;margin-bottom:18px}
  .txn label{font-size:10px;color:#888;text-transform:uppercase;letter-spacing:.08em;display:block;margin-bottom:3px}
  .txn span{font-size:15px;font-weight:700;color:#92400e}
  .frow{padding:7px 12px;background:#f9f9f9;border:1px solid #eee;border-radius:6px;margin-bottom:5px;font-size:13px}
  .footer{margin-top:36px;padding-top:14px;border-top:1px solid #eee;font-size:11px;color:#888;text-align:center}
</style></head><body>
<div class="logo">TAXRELIEFGH</div>
<h1>Tax Relief Application</h1>
<p class="sub">${app.id} &nbsp;·&nbsp; ${new Date(app.submittedAt).toLocaleDateString("en-GB")} &nbsp;·&nbsp; ${app.userRegion||""} ${app.userTown?`, ${app.userTown}`:""}</p>
<div class="badge">Status: ${(app.status||"").replace(/_/g," ").toUpperCase()}</div>
${app.transactionId?`<div class="txn"><label>Transaction ID</label><span>${app.transactionId}</span> &nbsp; <span style="color:#888;font-size:12px">via ${app.paymentMethod||"—"} &nbsp;|&nbsp; Ref: ${app.userUsername||""}</span></div>`:""}
<div class="section">Personal Details</div>
<div class="grid">
  <div class="field"><label>Full Name</label><span>${d.surname||""} ${d.otherNames||""}</span></div>
  <div class="field"><label>Gender</label><span>${d.gender==="M"?"Male":d.gender==="F"?"Female":"—"}</span></div>
  <div class="field"><label>Date of Birth</label><span>${d.dob||"—"}</span></div>
  <div class="field"><label>Ghana Card No.</label><span>${d.ghanaCardNo||"—"}</span></div>
  <div class="field"><label>SSNIT No.</label><span>${d.socialSecNo||"—"}</span></div>
  <div class="field"><label>Tax File No.</label><span>${d.taxFileNo||"—"}</span></div>
  <div class="field"><label>Phone</label><span>${d.telephone||"—"}</span></div>
  <div class="field"><label>Mother's Maiden Name</label><span>${d.motherMaidenName||"—"}</span></div>
</div>
<div class="section">Employment & Location</div>
<div class="grid">
  <div class="field"><label>Sector</label><span>${d.sector||"—"}</span></div>
  <div class="field"><label>Employer</label><span>${d.employerName||"—"}</span></div>
  <div class="field"><label>Address</label><span>${d.employerAddress||"—"}</span></div>
  <div class="field"><label>Occupation</label><span>${app.userOccupation||"—"}</span></div>
  <div class="field"><label>Region</label><span>${app.userRegion||"—"}</span></div>
  <div class="field"><label>Town</label><span>${app.userTown||"—"}</span></div>
</div>
<div class="section">Family</div>
<div class="grid">
  <div class="field"><label>Marital Status</label><span>${d.maritalStatus||"—"}</span></div>
  <div class="field"><label>Spouse</label><span>${d.spouseName||"—"}</span></div><div class="field"><label>Spouse Ghana Card</label><span>${d.spouseGhanaCard||"—"}</span></div><div class="field"><label>Spouse SSNIT</label><span>${d.spouseSsnit||"—"}</span></div>
  <div class="field"><label>Children</label><span>${d.numChildren||"0"}</span></div>
  <div class="field"><label>Disabled</label><span>${d.disabled==="yes"?"Yes":"No"}</span></div>
</div>
${ch.length>0?`<div class="section">Children</div><table><thead><tr><th>#</th><th>Name</th><th>Date of Birth</th><th>School</th></tr></thead><tbody>${ch.map((c,i)=>`<tr><td>${i+1}</td><td>${c.name||"—"}</td><td>${c.dob||"—"}</td><td>${c.school||"—"}</td></tr>`).join("")}</tbody></table>`:""}
<div class="section">Attached Documents (${allFiles.length})</div>
${allFiles.length?allFiles.map(f=>`<div class="frow">📄 ${f.name||f}</div>`).join(""):"<p style='color:#888;font-size:13px'>None</p>"}
<div class="footer">TaxReliefGH · Settlers GH &nbsp;·&nbsp; ${new Date().toLocaleString("en-GB")} &nbsp;·&nbsp; ${app.id}</div>
</body></html>`;
    const win=window.open("","_blank");
    if(!win){alert("Allow pop-ups to print.");return;}
    win.document.write(html);
    win.document.close();
    setTimeout(()=>win.print(),600);
  };

  const hasDownloadable=displayFiles.some(f=>f&&(f.data||f.url));

  return(
    <div className="movo" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()} style={{maxHeight:"90vh",overflowY:"auto"}}>
        <div className="mhd">
          <div>
            <h3 style={{fontSize:18,fontFamily:"Syne,sans-serif"}}>Application Details</h3>
            <p style={{fontSize:11.5,color:"var(--muted)"}}>{app.id} · {new Date(app.submittedAt).toLocaleDateString("en-GB")}</p>
          </div>
          <button className="mclose" onClick={onClose}>✕</button>
        </div>

        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:16,alignItems:"center"}}>
          <SBadge s={app.status}/>
          <span className="rid">📍 {app.userRegion}{app.userTown?` · ${app.userTown}`:""}</span>
        </div>

        {/* Action buttons */}
        <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:20,padding:"14px 16px",background:"linear-gradient(135deg,#e6f4ed,#f0faf4)",border:"1.5px solid #b3dfc5",borderRadius:10}}>
          <button onClick={printApplication} style={{display:"flex",alignItems:"center",gap:8,padding:"11px 18px",background:"#0f1923",color:"#F5C842",border:"none",borderRadius:8,cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13}}>
            🖨️ Print / Save as PDF
          </button>
          {hasDownloadable&&(
            <button onClick={downloadAllFiles} style={{display:"flex",alignItems:"center",gap:8,padding:"11px 18px",background:"#006B3F",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13}}>
              ⬇️ Download All ({displayFiles.filter(f=>f&&(f.data||f.url)).length})
            </button>
          )}
        </div>

        {/* Transaction info */}
        {app.transactionId&&(
          <div style={{background:"#fff8e6",border:"1.5px solid #C9991A",borderRadius:8,padding:"12px 16px",marginBottom:16,display:"flex",gap:20,flexWrap:"wrap"}}>
            <div><p style={{fontSize:10,color:"#888",textTransform:"uppercase",letterSpacing:".08em",marginBottom:2}}>Transaction ID</p><p style={{fontWeight:700,fontSize:15,color:"#92400e",fontFamily:"Syne,sans-serif"}}>{app.transactionId}</p></div>
            <div><p style={{fontSize:10,color:"#888",textTransform:"uppercase",letterSpacing:".08em",marginBottom:2}}>Method</p><p style={{fontWeight:700,fontSize:15,color:"#92400e",fontFamily:"Syne,sans-serif"}}>{app.paymentMethod||"—"}</p></div>
            <div><p style={{fontSize:10,color:"#888",textTransform:"uppercase",letterSpacing:".08em",marginBottom:2}}>Username / Reference</p><p style={{fontWeight:700,fontSize:15,color:"#92400e",fontFamily:"Syne,sans-serif"}}>{app.userUsername||app.userName||"—"}</p></div>
          </div>
        )}

        <div className="sdiv">Personal Details</div>
        <div className="dg">
          {[["Full Name",`${d.surname||""} ${d.otherNames||""}`],["Gender",d.gender==="M"?"Male":d.gender==="F"?"Female":"—"],["Date of Birth",d.dob||"—"],["Ghana Card No.",d.ghanaCardNo||"—"],["SSNIT No.",d.socialSecNo||"—"],["Tax File No.",d.taxFileNo||"—"],["Phone",d.telephone||"—"],["Mother Maiden Name",d.motherMaidenName||"—"]].map(([l,v])=>(
            <div key={l} className="di"><div className="dl">{l}</div><div className="dv">{v||"—"}</div></div>
          ))}
        </div>

        <div className="sdiv">Employment & Location</div>
        <div className="dg">
          {[["Sector",d.sector||"—"],["Employer",d.employerName||"—"],["Address",d.employerAddress||"—"],["Region",app.userRegion||"—"],["Town",app.userTown||"—"],["Occupation",app.userOccupation||"—"]].map(([l,v])=>(
            <div key={l} className="di"><div className="dl">{l}</div><div className="dv">{v||"—"}</div></div>
          ))}
        </div>

        <div className="sdiv">Family</div>
        <div className="dg">
          {[["Marital Status",d.maritalStatus||"—"],["Spouse Name",d.spouseName||"—"],["Spouse DOB",d.spouseDob||"—"],["Spouse Ghana Card",d.spouseGhanaCard||"—"],["Spouse SSNIT",d.spouseSsnit||"—"],["Children",d.numChildren||"0"],["Disabled",d.disabled==="yes"?"Yes":"No"]].map(([l,v])=>(
            <div key={l} className="di"><div className="dl">{l}</div><div className="dv">{v||"—"}</div></div>
          ))}
        </div>

        {parseInt(d.numChildren)>0&&(
          <><div className="sdiv">Children</div>
          <table className="ctbl" style={{marginBottom:16}}>
            <thead><tr><th>#</th><th>Name</th><th>Date of Birth</th><th>School</th></tr></thead>
            <tbody>{d.children?.slice(0,parseInt(d.numChildren)).map((c,i)=>(<tr key={i}><td>{i+1}</td><td>{c.name||"—"}</td><td>{c.dob||"—"}</td><td>{c.school||"—"}</td></tr>))}</tbody>
          </table></>
        )}

        {/* Attached documents */}
        <div className="sdiv">
          Attached Documents ({fetchingFiles?"loading...":displayFiles.length})
        </div>
        {fetchingFiles&&(
          <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px",background:"#f0f4ff",borderRadius:8,marginBottom:12,fontSize:13,color:"#3b5bdb",fontFamily:"Syne,sans-serif",fontWeight:600}}>
            <span style={{fontSize:22}}>⏳</span> Loading files from server...
          </div>
        )}
        {!fetchingFiles&&displayFiles.length===0&&(
          <p style={{fontSize:13,color:"var(--muted)",marginBottom:16}}>No documents attached.</p>
        )}
        <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:20}}>
          {!fetchingFiles&&displayFiles.map((file,i)=>{
            const fname=file.name||`File ${i+1}`;
            const canDl=!!(file.data||file.driveUrl||file.url);
            const isImg=/\.(jpg|jpeg|png|gif|webp)$/i.test(fname);
            return(
              <div key={i} style={{
                display:"flex",alignItems:"center",justifyContent:"space-between",
                background:canDl?"#f0faf4":"#f9f9f9",
                border:canDl?"1.5px solid #b3dfc5":"1px solid #e0e0e0",
                borderRadius:8,padding:"11px 14px",gap:12
              }}>
                <div style={{display:"flex",alignItems:"center",gap:10,flex:1,minWidth:0}}>
                  <span style={{fontSize:22,flexShrink:0}}>{isImg?"🖼️":"📄"}</span>
                  <div style={{minWidth:0}}>
                    <p style={{fontSize:13,fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--ink)",margin:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{fname}</p>
                    <p style={{fontSize:11,color:canDl?"#006B3F":"#999",margin:"2px 0 0",fontWeight:600}}>{file.driveUrl?"☁️ Google Drive":canDl?"✅ Firebase":"⚠️ Old submission"}</p>
                  </div>
                </div>
                {canDl?(
                  <button onClick={()=>downloadFile(file)} style={{
                    background:"#006B3F",color:"#fff",border:"none",
                    padding:"9px 18px",borderRadius:7,cursor:"pointer",
                    fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13,
                    whiteSpace:"nowrap",flexShrink:0
                  }}>{file.driveUrl?"☁️ Open Drive":"⬇ Download"}</button>
                ):(
                  <span style={{fontSize:11,color:"#999",flexShrink:0,fontStyle:"italic"}}>Old submission</span>
                )}
              </div>
            );
          })}
        </div>

        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          <button onClick={printApplication} style={{flex:1,padding:"13px",background:"#0f1923",color:"#F5C842",border:"none",borderRadius:8,cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13}}>
            🖨️ Print / Save as PDF
          </button>
          {onSendMsg&&(
            <div style={{marginBottom:16,background:"var(--card)",border:"1.5px solid var(--bdr)",borderRadius:10,padding:"16px",gridColumn:"1/-1"}}>
              <h4 style={{margin:"0 0 10px",fontSize:13,fontFamily:"Syne,sans-serif",color:"var(--ink)",fontWeight:700,textTransform:"uppercase",letterSpacing:".05em"}}>
                ✉️ Send Message to Applicant
              </h4>
              {app.messages&&app.messages.length>0&&(
                <div style={{marginBottom:12,maxHeight:140,overflowY:"auto"}}>
                  {app.messages.map((m,i)=>(
                    <div key={i} style={{background:m.from==="client"?"#e8f4fd":"#f0fdf4",border:"1px solid "+( m.from==="client"?"#bfdbfe":"#bbf7d0"),borderRadius:7,padding:"8px 12px",marginBottom:6}}>
                      <div style={{fontSize:11,color:"#666",marginBottom:3,fontWeight:600}}>
                        {m.from==="client"?"👤 Applicant":"🔒 Admin"} · {new Date(m.date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}
                        {!m.read&&m.from!=="client"&&<span style={{marginLeft:8,background:"#f59e0b",color:"#fff",borderRadius:10,padding:"1px 7px",fontSize:10,fontWeight:700}}>Sent</span>}
                      </div>
                      <p style={{margin:0,fontSize:13,color:"var(--ink)",lineHeight:1.5}}>{m.text}</p>
                    </div>
                  ))}
                </div>
              )}
              <textarea
                value={msgText}
                onChange={e=>setMsgText(e.target.value)}
                placeholder="Type a message to the applicant — e.g. 'Please upload your latest payslip' or 'Your Ghana Card number is missing'..."
                style={{width:"100%",minHeight:80,padding:"10px 12px",borderRadius:8,border:"1.5px solid var(--bdr)",background:"var(--bg)",color:"var(--ink)",fontSize:13,fontFamily:"Syne,sans-serif",resize:"vertical",boxSizing:"border-box",marginBottom:8}}
              />
              {msgSent&&<p style={{color:"#059669",fontSize:12,fontWeight:600,margin:"0 0 8px"}}>✅ Message sent! Client will see it on their dashboard.</p>}
              <button
                disabled={sendingMsg||!msgText.trim()}
                onClick={async()=>{
                  setSendingMsg(true);
                  const ok=await onSendMsg(app.id,msgText,"admin");
                  if(ok){setMsgText("");setMsgSent(true);setTimeout(()=>setMsgSent(false),4000);}
                  setSendingMsg(false);
                }}
                style={{padding:"9px 22px",background:msgText.trim()?"#006B3F":"#ccc",color:"#fff",border:"none",borderRadius:8,cursor:msgText.trim()?"pointer":"not-allowed",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:13}}
              >{sendingMsg?"Sending...":"📤 Send Message"}</button>
            </div>
          )}
          <button onClick={onClose} style={{flex:1,padding:"13px",background:"#c0392b",color:"#ffffff",border:"none",borderRadius:8,cursor:"pointer",fontFamily:"Syne,sans-serif",fontWeight:700,fontSize:14,letterSpacing:".05em"}}>✕ Close</button>
        </div>
      </div>
    </div>
  );
}


function SBadge({s}){
  const m={
    submitted:          "Form Submitted",
    payment_pending:    "Payment Pending",
    awaiting_approval:  "⏳ Awaiting Approval",
    approved:           "✅ Payment Approved",
    processing:         "⚙️ Processing",
    completed:          "🎉 Completed",
  };
  const colors={
    submitted:         {bg:"#e8f0fe",color:"#1a56db"},
    payment_pending:   {bg:"#fef3c7",color:"#92400e"},
    awaiting_approval: {bg:"#fef3c7",color:"#92400e"},
    approved:          {bg:"#e6f4ed",color:"#006B3F"},
    processing:        {bg:"#fff3e0",color:"#e65100"},
    completed:         {bg:"#e6f4ed",color:"#006B3F"},
  };
  const c=colors[s]||{bg:"#f0f0f0",color:"#333"};
  return <span style={{background:c.bg,color:c.color,padding:"4px 10px",borderRadius:20,fontSize:11,fontFamily:"Syne,sans-serif",fontWeight:700,whiteSpace:"nowrap"}}>{m[s]||s}</span>;
}
// ── Hubtel SMS Notifications ─────────────────────────────────────────────────
const SMS_CLIENT_ID  = "yaxnqtoi";
const SMS_CLIENT_SECRET = "zpwfshan";
const SMS_SENDER     = "TaxReliefGH";

async function sendSMS(to, message){
  if(!to) return;
  // Normalise Ghana number: 0244... → 233244...
  let phone = String(to).replace(/\s+/g,"").replace(/^0/,"233").replace(/^\+/,"");
  if(phone.length < 9) return;
  try{
    const url = `https://sms.hubtel.com/v1/messages/send?clientsecret=${SMS_CLIENT_SECRET}&clientid=${SMS_CLIENT_ID}&from=${SMS_SENDER}&to=${phone}&content=${encodeURIComponent(message)}`;
    await fetch(url);
    console.log("SMS sent to", phone);
  }catch(e){
    console.warn("SMS failed:", e.message);
  }
}
// ─────────────────────────────────────────────────────────────────────────────


